/*!
* reveal.js 5.0.0
* https://revealjs.com
* MIT licensed
*
* Copyright (C) 2011-2023 Hakim El Hattab, https://hakim.se
*/ !function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Reveal = t();
}(this, function() {
    "use strict";
    const e = (e, t)=>{
        for(let i in t)e[i] = t[i];
        return e;
    }, t = (e, t)=>Array.from(e.querySelectorAll(t)), i = (e, t, i)=>{
        i ? e.classList.add(t) : e.classList.remove(t);
    }, s = (e)=>{
        if ("string" == typeof e) {
            if ("null" === e) return null;
            if ("true" === e) return !0;
            if ("false" === e) return !1;
            if (e.match(/^-?[\d\.]+$/)) return parseFloat(e);
        }
        return e;
    }, a = (e, t)=>{
        e.style.transform = t;
    }, n = (e, t)=>{
        let i = e.matches || e.matchesSelector || e.msMatchesSelector;
        return !(!i || !i.call(e, t));
    }, r = (e, t)=>{
        if ("function" == typeof e.closest) return e.closest(t);
        for(; e;){
            if (n(e, t)) return e;
            e = e.parentNode;
        }
        return null;
    }, o = (e)=>{
        let t = document.createElement("style");
        return t.type = "text/css", e && e.length > 0 && (t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e))), document.head.appendChild(t), t;
    }, l = ()=>{
        let e = {};
        location.search.replace(/[A-Z0-9]+?=([\w\.%-]*)/gi, (t)=>{
            e[t.split("=").shift()] = t.split("=").pop();
        });
        for(let t in e){
            let i = e[t];
            e[t] = s(unescape(i));
        }
        return void 0 !== e.dependencies && delete e.dependencies, e;
    }, d = {
        mp4: "video/mp4",
        m4a: "video/mp4",
        ogv: "video/ogg",
        mpeg: "video/mpeg",
        webm: "video/webm"
    }, c = navigator.userAgent, h = /(iphone|ipod|ipad|android)/gi.test(c) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1, u = /android/gi.test(c);
    var g = function(e) {
        if (e) {
            var t = function(e) {
                return [].slice.call(e);
            }, i = 3, s = [], a = null, n = "requestAnimationFrame" in e ? function() {
                e.cancelAnimationFrame(a), a = e.requestAnimationFrame(function() {
                    return o(s.filter(function(e) {
                        return e.dirty && e.active;
                    }));
                });
            } : function() {}, r = function(e) {
                return function() {
                    s.forEach(function(t) {
                        return t.dirty = e;
                    }), n();
                };
            }, o = function(e) {
                e.filter(function(e) {
                    return !e.styleComputed;
                }).forEach(function(e) {
                    e.styleComputed = h(e);
                }), e.filter(u).forEach(g);
                var t = e.filter(c);
                t.forEach(d), t.forEach(function(e) {
                    g(e), l(e);
                }), t.forEach(p);
            }, l = function(e) {
                return e.dirty = 0;
            }, d = function(e) {
                e.availableWidth = e.element.parentNode.clientWidth, e.currentWidth = e.element.scrollWidth, e.previousFontSize = e.currentFontSize, e.currentFontSize = Math.min(Math.max(e.minSize, e.availableWidth / e.currentWidth * e.previousFontSize), e.maxSize), e.whiteSpace = e.multiLine && e.currentFontSize === e.minSize ? "normal" : "nowrap";
            }, c = function(e) {
                return 2 !== e.dirty || 2 === e.dirty && e.element.parentNode.clientWidth !== e.availableWidth;
            }, h = function(t) {
                var i = e.getComputedStyle(t.element, null);
                return t.currentFontSize = parseFloat(i.getPropertyValue("font-size")), t.display = i.getPropertyValue("display"), t.whiteSpace = i.getPropertyValue("white-space"), !0;
            }, u = function(e) {
                var t = !1;
                return !e.preStyleTestCompleted && (/inline-/.test(e.display) || (t = !0, e.display = "inline-block"), "nowrap" !== e.whiteSpace && (t = !0, e.whiteSpace = "nowrap"), e.preStyleTestCompleted = !0, t);
            }, g = function(e) {
                e.element.style.whiteSpace = e.whiteSpace, e.element.style.display = e.display, e.element.style.fontSize = e.currentFontSize + "px";
            }, p = function(e) {
                e.element.dispatchEvent(new CustomEvent("fit", {
                    detail: {
                        oldValue: e.previousFontSize,
                        newValue: e.currentFontSize,
                        scaleFactor: e.currentFontSize / e.previousFontSize
                    }
                }));
            }, v = function(e, t) {
                return function() {
                    e.dirty = t, e.active && n();
                };
            }, m = function(e) {
                return function() {
                    s = s.filter(function(t) {
                        return t.element !== e.element;
                    }), e.observeMutations && e.observer.disconnect(), e.element.style.whiteSpace = e.originalStyle.whiteSpace, e.element.style.display = e.originalStyle.display, e.element.style.fontSize = e.originalStyle.fontSize;
                };
            }, f = function(e) {
                return function() {
                    e.active || (e.active = !0, n());
                };
            }, y = function(e) {
                return function() {
                    return e.active = !1;
                };
            }, b = function(e) {
                e.observeMutations && (e.observer = new MutationObserver(v(e, 1)), e.observer.observe(e.element, e.observeMutations));
            }, w = {
                minSize: 16,
                maxSize: 512,
                multiLine: !0,
                observeMutations: "MutationObserver" in e && {
                    subtree: !0,
                    childList: !0,
                    characterData: !0
                }
            }, E = null, S = function() {
                e.clearTimeout(E), E = e.setTimeout(r(2), k.observeWindowDelay);
            }, A = [
                "resize",
                "orientationchange"
            ];
            return Object.defineProperty(k, "observeWindow", {
                set: function(t) {
                    var i = "".concat(t ? "add" : "remove", "EventListener");
                    A.forEach(function(t) {
                        e[i](t, S);
                    });
                }
            }), k.observeWindow = !0, k.observeWindowDelay = 100, k.fitAll = r(i), k;
        }
        function R(e, t) {
            var a = Object.assign({}, w, t), r = e.map(function(e) {
                var t = Object.assign({}, a, {
                    element: e,
                    active: !0
                });
                return function(e) {
                    e.originalStyle = {
                        whiteSpace: e.element.style.whiteSpace,
                        display: e.element.style.display,
                        fontSize: e.element.style.fontSize
                    }, b(e), e.newbie = !0, e.dirty = !0, s.push(e);
                }(t), {
                    element: e,
                    fit: v(t, i),
                    unfreeze: f(t),
                    freeze: y(t),
                    unsubscribe: m(t)
                };
            });
            return n(), r;
        }
        function k(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return "string" == typeof e ? R(t(document.querySelectorAll(e)), i) : R([
                e
            ], i)[0];
        }
    }("undefined" == typeof window ? null : window);
    class p {
        constructor(e){
            this.Reveal = e, this.startEmbeddedIframe = this.startEmbeddedIframe.bind(this);
        }
        shouldPreload(e) {
            if (this.Reveal.isScrollView()) return !0;
            let t = this.Reveal.getConfig().preloadIframes;
            return "boolean" != typeof t && (t = e.hasAttribute("data-preload")), t;
        }
        load(e, i = {}) {
            e.style.display = this.Reveal.getConfig().display, t(e, "img[data-src], video[data-src], audio[data-src], iframe[data-src]").forEach((e)=>{
                ("IFRAME" !== e.tagName || this.shouldPreload(e)) && (e.setAttribute("src", e.getAttribute("data-src")), e.setAttribute("data-lazy-loaded", ""), e.removeAttribute("data-src"));
            }), t(e, "video, audio").forEach((e)=>{
                let i = 0;
                t(e, "source[data-src]").forEach((e)=>{
                    e.setAttribute("src", e.getAttribute("data-src")), e.removeAttribute("data-src"), e.setAttribute("data-lazy-loaded", ""), i += 1;
                }), h && "VIDEO" === e.tagName && e.setAttribute("playsinline", ""), i > 0 && e.load();
            });
            let s = e.slideBackgroundElement;
            if (s) {
                s.style.display = "block";
                let t = e.slideBackgroundContentElement, a = e.getAttribute("data-background-iframe");
                if (!1 === s.hasAttribute("data-loaded")) {
                    s.setAttribute("data-loaded", "true");
                    let n = e.getAttribute("data-background-image"), r = e.getAttribute("data-background-video"), o = e.hasAttribute("data-background-video-loop"), l = e.hasAttribute("data-background-video-muted");
                    if (n) /^data:/.test(n.trim()) ? t.style.backgroundImage = `url(${n.trim()})` : t.style.backgroundImage = n.split(",").map((e)=>`url(${((e = "")=>encodeURI(e).replace(/%5B/g, "[").replace(/%5D/g, "]").replace(/[!'()*]/g, (e)=>`%${e.charCodeAt(0).toString(16).toUpperCase()}`))(decodeURI(e.trim()))})`).join(",");
                    else if (r && !this.Reveal.isSpeakerNotes()) {
                        let e = document.createElement("video");
                        o && e.setAttribute("loop", ""), l && (e.muted = !0), h && (e.muted = !0, e.setAttribute("playsinline", "")), r.split(",").forEach((t)=>{
                            let i = ((e = "")=>d[e.split(".").pop()])(t);
                            e.innerHTML += i ? `<source src="${t}" type="${i}">` : `<source src="${t}">`;
                        }), t.appendChild(e);
                    } else if (a && !0 !== i.excludeIframes) {
                        let e = document.createElement("iframe");
                        e.setAttribute("allowfullscreen", ""), e.setAttribute("mozallowfullscreen", ""), e.setAttribute("webkitallowfullscreen", ""), e.setAttribute("allow", "autoplay"), e.setAttribute("data-src", a), e.style.width = "100%", e.style.height = "100%", e.style.maxHeight = "100%", e.style.maxWidth = "100%", t.appendChild(e);
                    }
                }
                let n = t.querySelector("iframe[data-src]");
                n && this.shouldPreload(s) && !/autoplay=(1|true|yes)/gi.test(a) && n.getAttribute("src") !== a && n.setAttribute("src", a);
            }
            this.layout(e);
        }
        layout(e) {
            Array.from(e.querySelectorAll(".r-fit-text")).forEach((e)=>{
                g(e, {
                    minSize: 24,
                    maxSize: .8 * this.Reveal.getConfig().height,
                    observeMutations: !1,
                    observeWindow: !1
                });
            });
        }
        unload(e) {
            e.style.display = "none";
            let i = this.Reveal.getSlideBackground(e);
            i && (i.style.display = "none", t(i, "iframe[src]").forEach((e)=>{
                e.removeAttribute("src");
            })), t(e, "video[data-lazy-loaded][src], audio[data-lazy-loaded][src], iframe[data-lazy-loaded][src]").forEach((e)=>{
                e.setAttribute("data-src", e.getAttribute("src")), e.removeAttribute("src");
            }), t(e, "video[data-lazy-loaded] source[src], audio source[src]").forEach((e)=>{
                e.setAttribute("data-src", e.getAttribute("src")), e.removeAttribute("src");
            });
        }
        formatEmbeddedContent() {
            let e = (e, i, s)=>{
                t(this.Reveal.getSlidesElement(), "iframe[" + e + '*="' + i + '"]').forEach((t)=>{
                    let i = t.getAttribute(e);
                    i && -1 === i.indexOf(s) && t.setAttribute(e, i + (/\?/.test(i) ? "&" : "?") + s);
                });
            };
            e("src", "youtube.com/embed/", "enablejsapi=1"), e("data-src", "youtube.com/embed/", "enablejsapi=1"), e("src", "player.vimeo.com/", "api=1"), e("data-src", "player.vimeo.com/", "api=1");
        }
        startEmbeddedContent(e) {
            e && !this.Reveal.isSpeakerNotes() && (t(e, 'img[src$=".gif"]').forEach((e)=>{
                e.setAttribute("src", e.getAttribute("src"));
            }), t(e, "video, audio").forEach((e)=>{
                if (r(e, ".fragment") && !r(e, ".fragment.visible")) return;
                let t = this.Reveal.getConfig().autoPlayMedia;
                if ("boolean" != typeof t && (t = e.hasAttribute("data-autoplay") || !!r(e, ".slide-background")), t && "function" == typeof e.play) {
                    if (e.readyState > 1) this.startEmbeddedMedia({
                        target: e
                    });
                    else if (h) {
                        let t = e.play();
                        t && "function" == typeof t.catch && !1 === e.controls && t.catch(()=>{
                            e.controls = !0, e.addEventListener("play", ()=>{
                                e.controls = !1;
                            });
                        });
                    } else e.removeEventListener("loadeddata", this.startEmbeddedMedia), e.addEventListener("loadeddata", this.startEmbeddedMedia);
                }
            }), t(e, "iframe[src]").forEach((e)=>{
                r(e, ".fragment") && !r(e, ".fragment.visible") || this.startEmbeddedIframe({
                    target: e
                });
            }), t(e, "iframe[data-src]").forEach((e)=>{
                r(e, ".fragment") && !r(e, ".fragment.visible") || e.getAttribute("src") !== e.getAttribute("data-src") && (e.removeEventListener("load", this.startEmbeddedIframe), e.addEventListener("load", this.startEmbeddedIframe), e.setAttribute("src", e.getAttribute("data-src")));
            }));
        }
        startEmbeddedMedia(e) {
            let t = !!r(e.target, "html"), i = !!r(e.target, ".present");
            t && i && (e.target.currentTime = 0, e.target.play()), e.target.removeEventListener("loadeddata", this.startEmbeddedMedia);
        }
        startEmbeddedIframe(e) {
            let t = e.target;
            if (t && t.contentWindow) {
                let i = !!r(e.target, "html"), s = !!r(e.target, ".present");
                if (i && s) {
                    let e = this.Reveal.getConfig().autoPlayMedia;
                    "boolean" != typeof e && (e = t.hasAttribute("data-autoplay") || !!r(t, ".slide-background")), /youtube\.com\/embed\//.test(t.getAttribute("src")) && e ? t.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*") : /player\.vimeo\.com\//.test(t.getAttribute("src")) && e ? t.contentWindow.postMessage('{"method":"play"}', "*") : t.contentWindow.postMessage("slide:start", "*");
                }
            }
        }
        stopEmbeddedContent(i, s = {}) {
            s = e({
                unloadIframes: !0
            }, s), i && i.parentNode && (t(i, "video, audio").forEach((e)=>{
                e.hasAttribute("data-ignore") || "function" != typeof e.pause || (e.setAttribute("data-paused-by-reveal", ""), e.pause());
            }), t(i, "iframe").forEach((e)=>{
                e.contentWindow && e.contentWindow.postMessage("slide:stop", "*"), e.removeEventListener("load", this.startEmbeddedIframe);
            }), t(i, 'iframe[src*="youtube.com/embed/"]').forEach((e)=>{
                !e.hasAttribute("data-ignore") && e.contentWindow && "function" == typeof e.contentWindow.postMessage && e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }), t(i, 'iframe[src*="player.vimeo.com/"]').forEach((e)=>{
                !e.hasAttribute("data-ignore") && e.contentWindow && "function" == typeof e.contentWindow.postMessage && e.contentWindow.postMessage('{"method":"pause"}', "*");
            }), !0 === s.unloadIframes && t(i, "iframe[data-src]").forEach((e)=>{
                e.setAttribute("src", "about:blank"), e.removeAttribute("src");
            }));
        }
    }
    class v {
        constructor(e){
            this.Reveal = e;
        }
        render() {
            this.element = document.createElement("div"), this.element.className = "slide-number", this.Reveal.getRevealElement().appendChild(this.element);
        }
        configure(e, t) {
            let i = "none";
            e.slideNumber && !this.Reveal.isPrintView() && ("all" === e.showSlideNumber || "speaker" === e.showSlideNumber && this.Reveal.isSpeakerNotes()) && (i = "block"), this.element.style.display = i;
        }
        update() {
            this.Reveal.getConfig().slideNumber && this.element && (this.element.innerHTML = this.getSlideNumber());
        }
        getSlideNumber(e = this.Reveal.getCurrentSlide()) {
            let t, i = this.Reveal.getConfig(), s = "h.v";
            if ("function" == typeof i.slideNumber) t = i.slideNumber(e);
            else {
                "string" == typeof i.slideNumber && (s = i.slideNumber), /c/.test(s) || 1 !== this.Reveal.getHorizontalSlides().length || (s = "c");
                let a = e && "uncounted" === e.dataset.visibility ? 0 : 1;
                switch(t = [], s){
                    case "c":
                        t.push(this.Reveal.getSlidePastCount(e) + a);
                        break;
                    case "c/t":
                        t.push(this.Reveal.getSlidePastCount(e) + a, "/", this.Reveal.getTotalSlides());
                        break;
                    default:
                        let i1 = this.Reveal.getIndices(e);
                        t.push(i1.h + a);
                        let n = "h/v" === s ? "/" : ".";
                        this.Reveal.isVerticalSlide(e) && t.push(n, i1.v + 1);
                }
            }
            let a = "#" + this.Reveal.location.getHash(e);
            return this.formatNumber(t[0], t[1], t[2], a);
        }
        formatNumber(e, t, i, s = "#" + this.Reveal.location.getHash()) {
            return "number" != typeof i || isNaN(i) ? `<a href="${s}">\n\t\t\t\t\t<span class="slide-number-a">${e}</span>\n\t\t\t\t\t</a>` : `<a href="${s}">\n\t\t\t\t\t<span class="slide-number-a">${e}</span>\n\t\t\t\t\t<span class="slide-number-delimiter">${t}</span>\n\t\t\t\t\t<span class="slide-number-b">${i}</span>\n\t\t\t\t\t</a>`;
        }
        destroy() {
            this.element.remove();
        }
    }
    class m {
        constructor(e){
            this.Reveal = e, this.onInput = this.onInput.bind(this), this.onBlur = this.onBlur.bind(this), this.onKeyDown = this.onKeyDown.bind(this);
        }
        render() {
            this.element = document.createElement("div"), this.element.className = "jump-to-slide", this.jumpInput = document.createElement("input"), this.jumpInput.type = "text", this.jumpInput.className = "jump-to-slide-input", this.jumpInput.placeholder = "Jump to slide", this.jumpInput.addEventListener("input", this.onInput), this.jumpInput.addEventListener("keydown", this.onKeyDown), this.jumpInput.addEventListener("blur", this.onBlur), this.element.appendChild(this.jumpInput);
        }
        show() {
            this.indicesOnShow = this.Reveal.getIndices(), this.Reveal.getRevealElement().appendChild(this.element), this.jumpInput.focus();
        }
        hide() {
            this.isVisible() && (this.element.remove(), this.jumpInput.value = "", clearTimeout(this.jumpTimeout), delete this.jumpTimeout);
        }
        isVisible() {
            return !!this.element.parentNode;
        }
        jump() {
            clearTimeout(this.jumpTimeout), delete this.jumpTimeout;
            const e = this.jumpInput.value.trim("");
            let t = this.Reveal.location.getIndicesFromHash(e, {
                oneBasedIndex: !0
            });
            return !t && /\S+/i.test(e) && e.length > 1 && (t = this.search(e)), t && "" !== e ? (this.Reveal.slide(t.h, t.v, t.f), !0) : (this.Reveal.slide(this.indicesOnShow.h, this.indicesOnShow.v, this.indicesOnShow.f), !1);
        }
        jumpAfter(e) {
            clearTimeout(this.jumpTimeout), this.jumpTimeout = setTimeout(()=>this.jump(), e);
        }
        search(e) {
            const t = new RegExp("\\b" + e.trim() + "\\b", "i"), i = this.Reveal.getSlides().find((e)=>t.test(e.innerText));
            return i ? this.Reveal.getIndices(i) : null;
        }
        cancel() {
            this.Reveal.slide(this.indicesOnShow.h, this.indicesOnShow.v, this.indicesOnShow.f), this.hide();
        }
        confirm() {
            this.jump(), this.hide();
        }
        destroy() {
            this.jumpInput.removeEventListener("input", this.onInput), this.jumpInput.removeEventListener("keydown", this.onKeyDown), this.jumpInput.removeEventListener("blur", this.onBlur), this.element.remove();
        }
        onKeyDown(e) {
            13 === e.keyCode ? this.confirm() : 27 === e.keyCode && (this.cancel(), e.stopImmediatePropagation());
        }
        onInput(e) {
            this.jumpAfter(200);
        }
        onBlur() {
            setTimeout(()=>this.hide(), 1);
        }
    }
    const f = (e)=>{
        let t = e.match(/^#([0-9a-f]{3})$/i);
        if (t && t[1]) return t = t[1], {
            r: 17 * parseInt(t.charAt(0), 16),
            g: 17 * parseInt(t.charAt(1), 16),
            b: 17 * parseInt(t.charAt(2), 16)
        };
        let i = e.match(/^#([0-9a-f]{6})$/i);
        if (i && i[1]) return i = i[1], {
            r: parseInt(i.slice(0, 2), 16),
            g: parseInt(i.slice(2, 4), 16),
            b: parseInt(i.slice(4, 6), 16)
        };
        let s = e.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
        if (s) return {
            r: parseInt(s[1], 10),
            g: parseInt(s[2], 10),
            b: parseInt(s[3], 10)
        };
        let a = e.match(/^rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\,\s*([\d]+|[\d]*.[\d]+)\s*\)$/i);
        return a ? {
            r: parseInt(a[1], 10),
            g: parseInt(a[2], 10),
            b: parseInt(a[3], 10),
            a: parseFloat(a[4])
        } : null;
    };
    class y {
        constructor(e){
            this.Reveal = e;
        }
        render() {
            this.element = document.createElement("div"), this.element.className = "backgrounds", this.Reveal.getRevealElement().appendChild(this.element);
        }
        create() {
            this.element.innerHTML = "", this.element.classList.add("no-transition"), this.Reveal.getHorizontalSlides().forEach((e)=>{
                let i = this.createBackground(e, this.element);
                t(e, "section").forEach((e)=>{
                    this.createBackground(e, i), i.classList.add("stack");
                });
            }), this.Reveal.getConfig().parallaxBackgroundImage ? (this.element.style.backgroundImage = 'url("' + this.Reveal.getConfig().parallaxBackgroundImage + '")', this.element.style.backgroundSize = this.Reveal.getConfig().parallaxBackgroundSize, this.element.style.backgroundRepeat = this.Reveal.getConfig().parallaxBackgroundRepeat, this.element.style.backgroundPosition = this.Reveal.getConfig().parallaxBackgroundPosition, setTimeout(()=>{
                this.Reveal.getRevealElement().classList.add("has-parallax-background");
            }, 1)) : (this.element.style.backgroundImage = "", this.Reveal.getRevealElement().classList.remove("has-parallax-background"));
        }
        createBackground(e, t) {
            let i = document.createElement("div");
            i.className = "slide-background " + e.className.replace(/present|past|future/, "");
            let s = document.createElement("div");
            return s.className = "slide-background-content", i.appendChild(s), t.appendChild(i), e.slideBackgroundElement = i, e.slideBackgroundContentElement = s, this.sync(e), i;
        }
        sync(e) {
            const t = e.slideBackgroundElement, i = e.slideBackgroundContentElement, s = {
                background: e.getAttribute("data-background"),
                backgroundSize: e.getAttribute("data-background-size"),
                backgroundImage: e.getAttribute("data-background-image"),
                backgroundVideo: e.getAttribute("data-background-video"),
                backgroundIframe: e.getAttribute("data-background-iframe"),
                backgroundColor: e.getAttribute("data-background-color"),
                backgroundGradient: e.getAttribute("data-background-gradient"),
                backgroundRepeat: e.getAttribute("data-background-repeat"),
                backgroundPosition: e.getAttribute("data-background-position"),
                backgroundTransition: e.getAttribute("data-background-transition"),
                backgroundOpacity: e.getAttribute("data-background-opacity")
            }, a = e.hasAttribute("data-preload");
            e.classList.remove("has-dark-background"), e.classList.remove("has-light-background"), t.removeAttribute("data-loaded"), t.removeAttribute("data-background-hash"), t.removeAttribute("data-background-size"), t.removeAttribute("data-background-transition"), t.style.backgroundColor = "", i.style.backgroundSize = "", i.style.backgroundRepeat = "", i.style.backgroundPosition = "", i.style.backgroundImage = "", i.style.opacity = "", i.innerHTML = "", s.background && (/^(http|file|\/\/)/gi.test(s.background) || /\.(svg|png|jpg|jpeg|gif|bmp|webp)([?#\s]|$)/gi.test(s.background) ? e.setAttribute("data-background-image", s.background) : t.style.background = s.background), (s.background || s.backgroundColor || s.backgroundGradient || s.backgroundImage || s.backgroundVideo || s.backgroundIframe) && t.setAttribute("data-background-hash", s.background + s.backgroundSize + s.backgroundImage + s.backgroundVideo + s.backgroundIframe + s.backgroundColor + s.backgroundGradient + s.backgroundRepeat + s.backgroundPosition + s.backgroundTransition + s.backgroundOpacity), s.backgroundSize && t.setAttribute("data-background-size", s.backgroundSize), s.backgroundColor && (t.style.backgroundColor = s.backgroundColor), s.backgroundGradient && (t.style.backgroundImage = s.backgroundGradient), s.backgroundTransition && t.setAttribute("data-background-transition", s.backgroundTransition), a && t.setAttribute("data-preload", ""), s.backgroundSize && (i.style.backgroundSize = s.backgroundSize), s.backgroundRepeat && (i.style.backgroundRepeat = s.backgroundRepeat), s.backgroundPosition && (i.style.backgroundPosition = s.backgroundPosition), s.backgroundOpacity && (i.style.opacity = s.backgroundOpacity);
            const n = this.getContrastClass(e);
            "string" == typeof n && e.classList.add(n);
        }
        getContrastClass(e) {
            const t = e.slideBackgroundElement;
            let i = e.getAttribute("data-background-color");
            if (!i || !f(i)) {
                let e = window.getComputedStyle(t);
                e && e.backgroundColor && (i = e.backgroundColor);
            }
            if (i) {
                const e = f(i);
                if (e && 0 !== e.a) return "string" == typeof (s = i) && (s = f(s)), (s ? (299 * s.r + 587 * s.g + 114 * s.b) / 1e3 : null) < 128 ? "has-dark-background" : "has-light-background";
            }
            var s;
            return null;
        }
        bubbleSlideContrastClassToElement(e, t) {
            [
                "has-light-background",
                "has-dark-background"
            ].forEach((i)=>{
                e.classList.contains(i) ? t.classList.add(i) : t.classList.remove(i);
            }, this);
        }
        update(e = !1) {
            let i = this.Reveal.getCurrentSlide(), s = this.Reveal.getIndices(), a = null, n = this.Reveal.getConfig().rtl ? "future" : "past", r = this.Reveal.getConfig().rtl ? "past" : "future";
            if (Array.from(this.element.childNodes).forEach((i, o)=>{
                i.classList.remove("past", "present", "future"), o < s.h ? i.classList.add(n) : o > s.h ? i.classList.add(r) : (i.classList.add("present"), a = i), (e || o === s.h) && t(i, ".slide-background").forEach((e, t)=>{
                    e.classList.remove("past", "present", "future");
                    const i = "number" == typeof s.v ? s.v : 0;
                    t < i ? e.classList.add("past") : t > i ? e.classList.add("future") : (e.classList.add("present"), o === s.h && (a = e));
                });
            }), this.previousBackground && this.Reveal.slideContent.stopEmbeddedContent(this.previousBackground, {
                unloadIframes: !this.Reveal.slideContent.shouldPreload(this.previousBackground)
            }), a) {
                this.Reveal.slideContent.startEmbeddedContent(a);
                let e = a.querySelector(".slide-background-content");
                if (e) {
                    let t = e.style.backgroundImage || "";
                    /\.gif/i.test(t) && (e.style.backgroundImage = "", window.getComputedStyle(e).opacity, e.style.backgroundImage = t);
                }
                let t = this.previousBackground ? this.previousBackground.getAttribute("data-background-hash") : null, i = a.getAttribute("data-background-hash");
                i && i === t && a !== this.previousBackground && this.element.classList.add("no-transition"), this.previousBackground = a;
            }
            i && this.bubbleSlideContrastClassToElement(i, this.Reveal.getRevealElement()), setTimeout(()=>{
                this.element.classList.remove("no-transition");
            }, 1);
        }
        updateParallax() {
            let e = this.Reveal.getIndices();
            if (this.Reveal.getConfig().parallaxBackgroundImage) {
                let t, i, s = this.Reveal.getHorizontalSlides(), a = this.Reveal.getVerticalSlides(), n = this.element.style.backgroundSize.split(" ");
                1 === n.length ? t = i = parseInt(n[0], 10) : (t = parseInt(n[0], 10), i = parseInt(n[1], 10));
                let r, o, l = this.element.offsetWidth, d = s.length;
                r = "number" == typeof this.Reveal.getConfig().parallaxBackgroundHorizontal ? this.Reveal.getConfig().parallaxBackgroundHorizontal : d > 1 ? (t - l) / (d - 1) : 0, o = r * e.h * -1;
                let c, h, u = this.element.offsetHeight, g = a.length;
                c = "number" == typeof this.Reveal.getConfig().parallaxBackgroundVertical ? this.Reveal.getConfig().parallaxBackgroundVertical : (i - u) / (g - 1), h = g > 0 ? c * e.v : 0, this.element.style.backgroundPosition = o + "px " + -h + "px";
            }
        }
        destroy() {
            this.element.remove();
        }
    }
    const b = ".slides section", w = ".slides>section", E = ".slides>section.present>section", S = /registerPlugin|registerKeyboardShortcut|addKeyBinding|addEventListener|showPreview/, A = /fade-(down|up|right|left|out|in-then-out|in-then-semi-out)|semi-fade-out|current-visible|shrink|grow/;
    let R = 0;
    class k {
        constructor(e){
            this.Reveal = e;
        }
        run(e, t) {
            this.reset();
            let i = this.Reveal.getSlides(), s = i.indexOf(t), a = i.indexOf(e);
            if (e.hasAttribute("data-auto-animate") && t.hasAttribute("data-auto-animate") && e.getAttribute("data-auto-animate-id") === t.getAttribute("data-auto-animate-id") && !(s > a ? t : e).hasAttribute("data-auto-animate-restart")) {
                this.autoAnimateStyleSheet = this.autoAnimateStyleSheet || o();
                let i = this.getAutoAnimateOptions(t);
                e.dataset.autoAnimate = "pending", t.dataset.autoAnimate = "pending", i.slideDirection = s > a ? "forward" : "backward";
                let n = "none" === e.style.display;
                n && (e.style.display = this.Reveal.getConfig().display);
                let r = this.getAutoAnimatableElements(e, t).map((e)=>this.autoAnimateElements(e.from, e.to, e.options || {}, i, R++));
                if (n && (e.style.display = "none"), "false" !== t.dataset.autoAnimateUnmatched && !0 === this.Reveal.getConfig().autoAnimateUnmatched) {
                    let e = .8 * i.duration, s = .2 * i.duration;
                    this.getUnmatchedAutoAnimateElements(t).forEach((e)=>{
                        let t = this.getAutoAnimateOptions(e, i), s = "unmatched";
                        t.duration === i.duration && t.delay === i.delay || (s = "unmatched-" + R++, r.push(`[data-auto-animate="running"] [data-auto-animate-target="${s}"] { transition: opacity ${t.duration}s ease ${t.delay}s; }`)), e.dataset.autoAnimateTarget = s;
                    }, this), r.push(`[data-auto-animate="running"] [data-auto-animate-target="unmatched"] { transition: opacity ${e}s ease ${s}s; }`);
                }
                this.autoAnimateStyleSheet.innerHTML = r.join(""), requestAnimationFrame(()=>{
                    this.autoAnimateStyleSheet && (getComputedStyle(this.autoAnimateStyleSheet).fontWeight, t.dataset.autoAnimate = "running");
                }), this.Reveal.dispatchEvent({
                    type: "autoanimate",
                    data: {
                        fromSlide: e,
                        toSlide: t,
                        sheet: this.autoAnimateStyleSheet
                    }
                });
            }
        }
        reset() {
            t(this.Reveal.getRevealElement(), '[data-auto-animate]:not([data-auto-animate=""])').forEach((e)=>{
                e.dataset.autoAnimate = "";
            }), t(this.Reveal.getRevealElement(), "[data-auto-animate-target]").forEach((e)=>{
                delete e.dataset.autoAnimateTarget;
            }), this.autoAnimateStyleSheet && this.autoAnimateStyleSheet.parentNode && (this.autoAnimateStyleSheet.parentNode.removeChild(this.autoAnimateStyleSheet), this.autoAnimateStyleSheet = null);
        }
        autoAnimateElements(e, t, i, s, a) {
            e.dataset.autoAnimateTarget = "", t.dataset.autoAnimateTarget = a;
            let n = this.getAutoAnimateOptions(t, s);
            void 0 !== i.delay && (n.delay = i.delay), void 0 !== i.duration && (n.duration = i.duration), void 0 !== i.easing && (n.easing = i.easing);
            let r = this.getAutoAnimatableProperties("from", e, i), o = this.getAutoAnimatableProperties("to", t, i);
            if (t.classList.contains("fragment") && (delete o.styles.opacity, e.classList.contains("fragment"))) (e.className.match(A) || [
                ""
            ])[0] === (t.className.match(A) || [
                ""
            ])[0] && "forward" === s.slideDirection && t.classList.add("visible", "disabled");
            if (!1 !== i.translate || !1 !== i.scale) {
                let e = this.Reveal.getScale(), t = {
                    x: (r.x - o.x) / e,
                    y: (r.y - o.y) / e,
                    scaleX: r.width / o.width,
                    scaleY: r.height / o.height
                };
                t.x = Math.round(1e3 * t.x) / 1e3, t.y = Math.round(1e3 * t.y) / 1e3, t.scaleX = Math.round(1e3 * t.scaleX) / 1e3, t.scaleX = Math.round(1e3 * t.scaleX) / 1e3;
                let s = !1 !== i.translate && (0 !== t.x || 0 !== t.y), a = !1 !== i.scale && (0 !== t.scaleX || 0 !== t.scaleY);
                if (s || a) {
                    let e = [];
                    s && e.push(`translate(${t.x}px, ${t.y}px)`), a && e.push(`scale(${t.scaleX}, ${t.scaleY})`), r.styles.transform = e.join(" "), r.styles["transform-origin"] = "top left", o.styles.transform = "none";
                }
            }
            for(let e in o.styles){
                const t = o.styles[e], i = r.styles[e];
                t === i ? delete o.styles[e] : (!0 === t.explicitValue && (o.styles[e] = t.value), !0 === i.explicitValue && (r.styles[e] = i.value));
            }
            let l = "", d = Object.keys(o.styles);
            if (d.length > 0) r.styles.transition = "none", o.styles.transition = `all ${n.duration}s ${n.easing} ${n.delay}s`, o.styles["transition-property"] = d.join(", "), o.styles["will-change"] = d.join(", "), l = '[data-auto-animate-target="' + a + '"] {' + Object.keys(r.styles).map((e)=>e + ": " + r.styles[e] + " !important;").join("") + '}[data-auto-animate="running"] [data-auto-animate-target="' + a + '"] {' + Object.keys(o.styles).map((e)=>e + ": " + o.styles[e] + " !important;").join("") + "}";
            return l;
        }
        getAutoAnimateOptions(t, i) {
            let s = {
                easing: this.Reveal.getConfig().autoAnimateEasing,
                duration: this.Reveal.getConfig().autoAnimateDuration,
                delay: 0
            };
            if (s = e(s, i), t.parentNode) {
                let e = r(t.parentNode, "[data-auto-animate-target]");
                e && (s = this.getAutoAnimateOptions(e, s));
            }
            return t.dataset.autoAnimateEasing && (s.easing = t.dataset.autoAnimateEasing), t.dataset.autoAnimateDuration && (s.duration = parseFloat(t.dataset.autoAnimateDuration)), t.dataset.autoAnimateDelay && (s.delay = parseFloat(t.dataset.autoAnimateDelay)), s;
        }
        getAutoAnimatableProperties(e, t, i) {
            let s = this.Reveal.getConfig(), a = {
                styles: []
            };
            if (!1 !== i.translate || !1 !== i.scale) {
                let e;
                if ("function" == typeof i.measure) e = i.measure(t);
                else if (s.center) e = t.getBoundingClientRect();
                else {
                    let i = this.Reveal.getScale();
                    e = {
                        x: t.offsetLeft * i,
                        y: t.offsetTop * i,
                        width: t.offsetWidth * i,
                        height: t.offsetHeight * i
                    };
                }
                a.x = e.x, a.y = e.y, a.width = e.width, a.height = e.height;
            }
            const n = getComputedStyle(t);
            return (i.styles || s.autoAnimateStyles).forEach((t)=>{
                let i;
                "string" == typeof t && (t = {
                    property: t
                }), void 0 !== t.from && "from" === e ? i = {
                    value: t.from,
                    explicitValue: !0
                } : void 0 !== t.to && "to" === e ? i = {
                    value: t.to,
                    explicitValue: !0
                } : ("line-height" === t.property && (i = parseFloat(n["line-height"]) / parseFloat(n["font-size"])), isNaN(i) && (i = n[t.property])), "" !== i && (a.styles[t.property] = i);
            }), a;
        }
        getAutoAnimatableElements(e, t) {
            let i = ("function" == typeof this.Reveal.getConfig().autoAnimateMatcher ? this.Reveal.getConfig().autoAnimateMatcher : this.getAutoAnimatePairs).call(this, e, t), s = [];
            return i.filter((e, t)=>{
                if (-1 === s.indexOf(e.to)) return s.push(e.to), !0;
            });
        }
        getAutoAnimatePairs(e, t) {
            let i = [];
            const s = "h1, h2, h3, h4, h5, h6, p, li";
            return this.findAutoAnimateMatches(i, e, t, "[data-id]", (e)=>e.nodeName + ":::" + e.getAttribute("data-id")), this.findAutoAnimateMatches(i, e, t, s, (e)=>e.nodeName + ":::" + e.innerText), this.findAutoAnimateMatches(i, e, t, "img, video, iframe", (e)=>e.nodeName + ":::" + (e.getAttribute("src") || e.getAttribute("data-src"))), this.findAutoAnimateMatches(i, e, t, "pre", (e)=>e.nodeName + ":::" + e.innerText), i.forEach((e)=>{
                n(e.from, s) ? e.options = {
                    scale: !1
                } : n(e.from, "pre") && (e.options = {
                    scale: !1,
                    styles: [
                        "width",
                        "height"
                    ]
                }, this.findAutoAnimateMatches(i, e.from, e.to, ".hljs .hljs-ln-code", (e)=>e.textContent, {
                    scale: !1,
                    styles: [],
                    measure: this.getLocalBoundingBox.bind(this)
                }), this.findAutoAnimateMatches(i, e.from, e.to, ".hljs .hljs-ln-numbers[data-line-number]", (e)=>e.getAttribute("data-line-number"), {
                    scale: !1,
                    styles: [
                        "width"
                    ],
                    measure: this.getLocalBoundingBox.bind(this)
                }));
            }, this), i;
        }
        getLocalBoundingBox(e) {
            const t = this.Reveal.getScale();
            return {
                x: Math.round(e.offsetLeft * t * 100) / 100,
                y: Math.round(e.offsetTop * t * 100) / 100,
                width: Math.round(e.offsetWidth * t * 100) / 100,
                height: Math.round(e.offsetHeight * t * 100) / 100
            };
        }
        findAutoAnimateMatches(e, t, i, s, a, n) {
            let r = {}, o = {};
            [].slice.call(t.querySelectorAll(s)).forEach((e, t)=>{
                const i = a(e);
                "string" == typeof i && i.length && (r[i] = r[i] || [], r[i].push(e));
            }), [].slice.call(i.querySelectorAll(s)).forEach((t, i)=>{
                const s = a(t);
                let l;
                if (o[s] = o[s] || [], o[s].push(t), r[s]) {
                    const e = o[s].length - 1, t = r[s].length - 1;
                    r[s][e] ? (l = r[s][e], r[s][e] = null) : r[s][t] && (l = r[s][t], r[s][t] = null);
                }
                l && e.push({
                    from: l,
                    to: t,
                    options: n
                });
            });
        }
        getUnmatchedAutoAnimateElements(e) {
            return [].slice.call(e.children).reduce((e, t)=>{
                const i = t.querySelector("[data-auto-animate-target]");
                return t.hasAttribute("data-auto-animate-target") || i || e.push(t), t.querySelector("[data-auto-animate-target]") && (e = e.concat(this.getUnmatchedAutoAnimateElements(t))), e;
            }, []);
        }
    }
    class L {
        constructor(e){
            this.Reveal = e, this.active = !1, this.activatedCallbacks = [], this.onScroll = this.onScroll.bind(this);
        }
        activate() {
            if (this.active) return;
            const e = this.Reveal.getState();
            this.active = !0, this.slideHTMLBeforeActivation = this.Reveal.getSlidesElement().innerHTML;
            const i = t(this.Reveal.getRevealElement(), w);
            let s;
            this.viewportElement.classList.add("loading-scroll-mode", "reveal-scroll");
            const a = window.getComputedStyle(this.viewportElement);
            a && a.background && (s = a.background);
            const n = [], r = i[0].parentNode;
            let o;
            const l = (e, t, i)=>{
                let a;
                if (o && this.Reveal.shouldAutoAnimateBetween(o, e)) a = document.createElement("div"), a.className = "scroll-page-content scroll-auto-animate-page", a.style.display = "none", o.closest(".scroll-page-content").parentNode.appendChild(a);
                else {
                    const e = document.createElement("div");
                    e.className = "scroll-page", n.push(e), s && (e.style.background = s);
                    const t = document.createElement("div");
                    t.className = "scroll-page-sticky", e.appendChild(t), a = document.createElement("div"), a.className = "scroll-page-content", t.appendChild(a);
                }
                a.appendChild(e), e.classList.remove("past", "future"), e.setAttribute("data-index-h", t), e.setAttribute("data-index-v", i), e.slideBackgroundElement && (e.slideBackgroundElement.remove("past", "future"), a.insertBefore(e.slideBackgroundElement, e)), o = e;
            };
            i.forEach((e, t)=>{
                this.Reveal.isVerticalStack(e) ? e.querySelectorAll("section").forEach((e, i)=>{
                    l(e, t, i);
                }) : l(e, t, 0);
            }, this), this.createProgressBar(), t(this.Reveal.getRevealElement(), ".stack").forEach((e)=>e.remove()), n.forEach((e)=>r.appendChild(e)), this.Reveal.slideContent.layout(this.Reveal.getSlidesElement()), this.Reveal.layout(), this.Reveal.setState(e), this.activatedCallbacks.forEach((e)=>e()), this.activatedCallbacks = [], this.restoreScrollPosition(), this.viewportElement.classList.remove("loading-scroll-mode"), this.viewportElement.addEventListener("scroll", this.onScroll, {
                passive: !0
            });
        }
        deactivate() {
            if (!this.active) return;
            const e = this.Reveal.getState();
            this.active = !1, this.viewportElement.removeEventListener("scroll", this.onScroll), this.viewportElement.classList.remove("reveal-scroll"), this.removeProgressBar(), this.Reveal.getSlidesElement().innerHTML = this.slideHTMLBeforeActivation, this.Reveal.sync(), this.Reveal.setState(e), this.slideHTMLBeforeActivation = null;
        }
        toggle(e) {
            "boolean" == typeof e ? e ? this.activate() : this.deactivate() : this.isActive() ? this.deactivate() : this.activate();
        }
        isActive() {
            return this.active;
        }
        createProgressBar() {
            this.progressBar = document.createElement("div"), this.progressBar.className = "scrollbar", this.progressBarInner = document.createElement("div"), this.progressBarInner.className = "scrollbar-inner", this.progressBar.appendChild(this.progressBarInner), this.progressBarPlayhead = document.createElement("div"), this.progressBarPlayhead.className = "scrollbar-playhead", this.progressBarInner.appendChild(this.progressBarPlayhead), this.viewportElement.insertBefore(this.progressBar, this.viewportElement.firstChild);
            const e = (e)=>{
                let t = (e.clientY - this.progressBarInner.getBoundingClientRect().top) / this.progressBarHeight;
                t = Math.max(Math.min(t, 1), 0), this.viewportElement.scrollTop = t * (this.viewportElement.scrollHeight - this.viewportElement.offsetHeight);
            }, t = (i)=>{
                this.draggingProgressBar = !1, this.showProgressBar(), document.removeEventListener("mousemove", e), document.removeEventListener("mouseup", t);
            };
            this.progressBarInner.addEventListener("mousedown", (i)=>{
                i.preventDefault(), this.draggingProgressBar = !0, document.addEventListener("mousemove", e), document.addEventListener("mouseup", t), e(i);
            });
        }
        removeProgressBar() {
            this.progressBar && (this.progressBar.remove(), this.progressBar = null);
        }
        layout() {
            this.isActive() && (this.syncPages(), this.syncScrollPosition());
        }
        syncPages() {
            const e = this.Reveal.getConfig(), t = this.Reveal.getComputedSlideSize(window.innerWidth, window.innerHeight), i = this.Reveal.getScale(), s = "compact" === e.scrollLayout, a = this.viewportElement.offsetHeight, n = t.height * i, r = s ? n : a, o = s ? n : a;
            this.viewportElement.style.setProperty("--page-height", r + "px"), this.viewportElement.style.scrollSnapType = "string" == typeof e.scrollSnap ? `y ${e.scrollSnap}` : "", this.slideTriggers = [];
            const l = Array.from(this.Reveal.getRevealElement().querySelectorAll(".scroll-page"));
            this.pages = l.map((i)=>{
                const n = this.createPage({
                    pageElement: i,
                    slideElement: i.querySelector("section"),
                    stickyElement: i.querySelector(".scroll-page-sticky"),
                    contentElement: i.querySelector(".scroll-page-content"),
                    backgroundElement: i.querySelector(".slide-background"),
                    autoAnimateElements: i.querySelectorAll(".scroll-auto-animate-page"),
                    autoAnimatePages: []
                });
                n.pageElement.style.setProperty("--slide-height", !0 === e.center ? "auto" : t.height + "px"), this.slideTriggers.push({
                    page: n,
                    activate: ()=>this.activatePage(n),
                    deactivate: ()=>this.deactivatePage(n)
                }), this.createFragmentTriggersForPage(n), n.autoAnimateElements.length > 0 && this.createAutoAnimateTriggersForPage(n);
                let l = Math.max(n.scrollTriggers.length - 1, 0);
                l += n.autoAnimatePages.reduce((e, t)=>e + Math.max(t.scrollTriggers.length - 1, 0), n.autoAnimatePages.length), n.pageElement.querySelectorAll(".scroll-snap-point").forEach((e)=>e.remove());
                for(let e = 0; e < l + 1; e++){
                    const t = document.createElement("div");
                    t.className = "scroll-snap-point", t.style.height = o + "px", t.style.scrollSnapAlign = s ? "center" : "start", n.pageElement.appendChild(t), 0 === e && (t.style.marginTop = -o + "px");
                }
                return s && n.scrollTriggers.length > 0 ? (n.pageHeight = a, n.pageElement.style.setProperty("--page-height", a + "px")) : (n.pageHeight = r, n.pageElement.style.removeProperty("--page-height")), n.scrollPadding = o * l, n.totalHeight = n.pageHeight + n.scrollPadding, n.pageElement.style.setProperty("--page-scroll-padding", n.scrollPadding + "px"), l > 0 ? (n.stickyElement.style.position = "sticky", n.stickyElement.style.top = Math.max((a - n.pageHeight) / 2, 0) + "px") : (n.stickyElement.style.position = "relative", n.pageElement.style.scrollSnapAlign = n.pageHeight < a ? "center" : "start"), n;
            }), this.setTriggerRanges(), this.viewportElement.setAttribute("data-scrollbar", e.scrollProgress), e.scrollProgress && this.totalScrollTriggerCount > 1 ? (this.progressBar || this.createProgressBar(), this.syncProgressBar()) : this.removeProgressBar();
        }
        setTriggerRanges() {
            this.totalScrollTriggerCount = this.slideTriggers.reduce((e, t)=>e + Math.max(t.page.scrollTriggers.length, 1), 0);
            let e = 0;
            this.slideTriggers.forEach((t, i)=>{
                t.range = [
                    e,
                    e + Math.max(t.page.scrollTriggers.length, 1) / this.totalScrollTriggerCount
                ];
                const s = (t.range[1] - t.range[0]) / t.page.scrollTriggers.length;
                t.page.scrollTriggers.forEach((t, i)=>{
                    t.range = [
                        e + i * s,
                        e + (i + 1) * s
                    ];
                }), e = t.range[1];
            });
        }
        createFragmentTriggersForPage(e, t) {
            t = t || e.slideElement;
            const i = this.Reveal.fragments.sort(t.querySelectorAll(".fragment"), !0);
            return i.length && (e.fragments = this.Reveal.fragments.sort(t.querySelectorAll(".fragment:not(.disabled)")), e.scrollTriggers.push({
                activate: ()=>{
                    this.Reveal.fragments.update(-1, e.fragments, t);
                }
            }, ...i.map((i, s)=>({
                    activate: ()=>{
                        this.Reveal.fragments.update(s, e.fragments, t);
                    }
                })))), e.scrollTriggers.length;
        }
        createAutoAnimateTriggersForPage(e) {
            e.autoAnimateElements.length > 0 && this.slideTriggers.push(...Array.from(e.autoAnimateElements).map((t, i)=>{
                let s = this.createPage({
                    slideElement: t.querySelector("section"),
                    contentElement: t,
                    backgroundElement: t.querySelector(".slide-background")
                });
                return this.createFragmentTriggersForPage(s, s.slideElement), e.autoAnimatePages.push(s), {
                    page: s,
                    activate: ()=>this.activatePage(s),
                    deactivate: ()=>this.deactivatePage(s)
                };
            }));
        }
        createPage(e) {
            return e.scrollTriggers = [], e.indexh = parseInt(e.slideElement.getAttribute("data-index-h"), 10), e.indexv = parseInt(e.slideElement.getAttribute("data-index-v"), 10), e;
        }
        syncProgressBar() {
            this.progressBarInner.querySelectorAll(".scrollbar-slide").forEach((e)=>e.remove());
            const e = this.viewportElement.scrollHeight, t = this.viewportElement.offsetHeight, i = t / e;
            this.progressBarHeight = this.progressBarInner.offsetHeight, this.playheadHeight = Math.max(i * this.progressBarHeight, 8), this.progressBarScrollableHeight = this.progressBarHeight - this.playheadHeight;
            const s = t / e * this.progressBarHeight, a = Math.min(s / 8, 4);
            this.progressBarPlayhead.style.height = this.playheadHeight - a + "px", s > 6 ? this.slideTriggers.forEach((e)=>{
                const { page: t } = e;
                t.progressBarSlide = document.createElement("div"), t.progressBarSlide.className = "scrollbar-slide", t.progressBarSlide.style.top = e.range[0] * this.progressBarHeight + "px", t.progressBarSlide.style.height = (e.range[1] - e.range[0]) * this.progressBarHeight - a + "px", t.progressBarSlide.classList.toggle("has-triggers", t.scrollTriggers.length > 0), this.progressBarInner.appendChild(t.progressBarSlide), t.scrollTriggerElements = t.scrollTriggers.map((i, s)=>{
                    const n = document.createElement("div");
                    return n.className = "scrollbar-trigger", n.style.top = (i.range[0] - e.range[0]) * this.progressBarHeight + "px", n.style.height = (i.range[1] - i.range[0]) * this.progressBarHeight - a + "px", t.progressBarSlide.appendChild(n), 0 === s && (n.style.display = "none"), n;
                });
            }) : this.pages.forEach((e)=>e.progressBarSlide = null);
        }
        syncScrollPosition() {
            const e = this.viewportElement.offsetHeight, t = e / this.viewportElement.scrollHeight, i = this.viewportElement.scrollTop, s = this.viewportElement.scrollHeight - e, a = Math.max(Math.min(i / s, 1), 0), n = Math.max(Math.min((i + e / 2) / this.viewportElement.scrollHeight, 1), 0);
            let r;
            this.slideTriggers.forEach((e)=>{
                const { page: i } = e;
                a >= e.range[0] - 2 * t && a <= e.range[1] + 2 * t && !i.loaded ? (i.loaded = !0, this.Reveal.slideContent.load(i.slideElement)) : i.loaded && (i.loaded = !1, this.Reveal.slideContent.unload(i.slideElement)), a >= e.range[0] && a <= e.range[1] ? (this.activateTrigger(e), r = e.page) : e.active && this.deactivateTrigger(e);
            }), r && r.scrollTriggers.forEach((e)=>{
                n >= e.range[0] && n <= e.range[1] ? this.activateTrigger(e) : e.active && this.deactivateTrigger(e);
            }), this.setProgressBarValue(i / (this.viewportElement.scrollHeight - e));
        }
        setProgressBarValue(e) {
            this.progressBar && (this.progressBarPlayhead.style.transform = `translateY(${e * this.progressBarScrollableHeight}px)`, this.getAllPages().filter((e)=>e.progressBarSlide).forEach((e)=>{
                e.progressBarSlide.classList.toggle("active", !0 === e.active), e.scrollTriggers.forEach((t, i)=>{
                    e.scrollTriggerElements[i].classList.toggle("active", !0 === e.active && !0 === t.active);
                });
            }), this.showProgressBar());
        }
        showProgressBar() {
            this.progressBar.classList.add("visible"), clearTimeout(this.hideProgressBarTimeout), "auto" !== this.Reveal.getConfig().scrollProgress || this.draggingProgressBar || (this.hideProgressBarTimeout = setTimeout(()=>{
                this.progressBar && this.progressBar.classList.remove("visible");
            }, 500));
        }
        scrollToSlide(e) {
            if (this.active) {
                const t = this.getScrollTriggerBySlide(e);
                t && (this.viewportElement.scrollTop = t.range[0] * (this.viewportElement.scrollHeight - this.viewportElement.offsetHeight));
            } else this.activatedCallbacks.push(()=>this.scrollToSlide(e));
        }
        storeScrollPosition() {
            clearTimeout(this.storeScrollPositionTimeout), this.storeScrollPositionTimeout = setTimeout(()=>{
                sessionStorage.setItem("reveal-scroll-top", this.viewportElement.scrollTop), sessionStorage.setItem("reveal-scroll-origin", location.origin + location.pathname), this.storeScrollPositionTimeout = null;
            }, 50);
        }
        restoreScrollPosition() {
            const e = sessionStorage.getItem("reveal-scroll-top"), t = sessionStorage.getItem("reveal-scroll-origin");
            e && t === location.origin + location.pathname && (this.viewportElement.scrollTop = parseInt(e, 10));
        }
        activatePage(e) {
            if (!e.active) {
                e.active = !0;
                const { slideElement: t, backgroundElement: i, contentElement: s, indexh: a, indexv: n } = e;
                s.style.display = "block", t.classList.add("present"), i && i.classList.add("present"), this.Reveal.setCurrentScrollPage(t, a, n), this.Reveal.backgrounds.bubbleSlideContrastClassToElement(t, this.viewportElement), Array.from(s.parentNode.querySelectorAll(".scroll-page-content")).forEach((e)=>{
                    e !== s && (e.style.display = "none");
                });
            }
        }
        deactivatePage(e) {
            e.active && (e.active = !1, e.slideElement.classList.remove("present"), e.backgroundElement.classList.remove("present"));
        }
        activateTrigger(e) {
            e.active || (e.active = !0, e.activate());
        }
        deactivateTrigger(e) {
            e.active && (e.active = !1, e.deactivate && e.deactivate());
        }
        getSlideByIndices(e, t) {
            const i = this.getAllPages().find((i)=>i.indexh === e && i.indexv === t);
            return i ? i.slideElement : null;
        }
        getScrollTriggerBySlide(e) {
            return this.slideTriggers.find((t)=>t.page.slideElement === e);
        }
        getAllPages() {
            return this.pages.flatMap((e)=>[
                    e,
                    ...e.autoAnimatePages || []
                ]);
        }
        onScroll() {
            this.syncScrollPosition(), this.storeScrollPosition();
        }
        get viewportElement() {
            return this.Reveal.getViewportElement();
        }
    }
    class C {
        constructor(e){
            this.Reveal = e;
        }
        async activate() {
            const e = this.Reveal.getConfig(), i = t(this.Reveal.getRevealElement(), b), s = e.slideNumber && /all|print/i.test(e.showSlideNumber), a = this.Reveal.getComputedSlideSize(window.innerWidth, window.innerHeight), n = Math.floor(a.width * (1 + e.margin)), r = Math.floor(a.height * (1 + e.margin)), l = a.width, d = a.height;
            await new Promise(requestAnimationFrame), o("@page{size:" + n + "px " + r + "px; margin: 0px;}"), o(".reveal section>img, .reveal section>video, .reveal section>iframe{max-width: " + l + "px; max-height:" + d + "px}"), document.documentElement.classList.add("reveal-print", "print-pdf"), document.body.style.width = n + "px", document.body.style.height = r + "px";
            const c = this.Reveal.getViewportElement();
            let h;
            if (c) {
                const e = window.getComputedStyle(c);
                e && e.background && (h = e.background);
            }
            await new Promise(requestAnimationFrame), this.Reveal.layoutSlideContents(l, d), await new Promise(requestAnimationFrame);
            const u = i.map((e)=>e.scrollHeight), g = [], p = i[0].parentNode;
            let v = 1;
            i.forEach(function(i, a) {
                if (!1 === i.classList.contains("stack")) {
                    let o = (n - l) / 2, c = (r - d) / 2;
                    const p = u[a];
                    let m = Math.max(Math.ceil(p / r), 1);
                    m = Math.min(m, e.pdfMaxPagesPerSlide), (1 === m && e.center || i.classList.contains("center")) && (c = Math.max((r - p) / 2, 0));
                    const f = document.createElement("div");
                    if (g.push(f), f.className = "pdf-page", f.style.height = (r + e.pdfPageHeightOffset) * m + "px", h && (f.style.background = h), f.appendChild(i), i.style.left = o + "px", i.style.top = c + "px", i.style.width = l + "px", this.Reveal.slideContent.layout(i), i.slideBackgroundElement && f.insertBefore(i.slideBackgroundElement, i), e.showNotes) {
                        const t = this.Reveal.getSlideNotes(i);
                        if (t) {
                            const i = 8, s = "string" == typeof e.showNotes ? e.showNotes : "inline", a = document.createElement("div");
                            a.classList.add("speaker-notes"), a.classList.add("speaker-notes-pdf"), a.setAttribute("data-layout", s), a.innerHTML = t, "separate-page" === s ? g.push(a) : (a.style.left = i + "px", a.style.bottom = i + "px", a.style.width = n - 2 * i + "px", f.appendChild(a));
                        }
                    }
                    if (s) {
                        const e = document.createElement("div");
                        e.classList.add("slide-number"), e.classList.add("slide-number-pdf"), e.innerHTML = v++, f.appendChild(e);
                    }
                    if (e.pdfSeparateFragments) {
                        const e = this.Reveal.fragments.sort(f.querySelectorAll(".fragment"), !0);
                        let t;
                        e.forEach(function(e, i) {
                            t && t.forEach(function(e) {
                                e.classList.remove("current-fragment");
                            }), e.forEach(function(e) {
                                e.classList.add("visible", "current-fragment");
                            }, this);
                            const a = f.cloneNode(!0);
                            if (s) {
                                const e = i + 1;
                                a.querySelector(".slide-number-pdf").innerHTML += "." + e;
                            }
                            g.push(a), t = e;
                        }, this), e.forEach(function(e) {
                            e.forEach(function(e) {
                                e.classList.remove("visible", "current-fragment");
                            });
                        });
                    } else t(f, ".fragment:not(.fade-out)").forEach(function(e) {
                        e.classList.add("visible");
                    });
                }
            }, this), await new Promise(requestAnimationFrame), g.forEach((e)=>p.appendChild(e)), this.Reveal.slideContent.layout(this.Reveal.getSlidesElement()), this.Reveal.dispatchEvent({
                type: "pdf-ready"
            });
        }
        isActive() {
            return "print" === this.Reveal.getConfig().view;
        }
    }
    class x {
        constructor(e){
            this.Reveal = e;
        }
        configure(e, t) {
            !1 === e.fragments ? this.disable() : !1 === t.fragments && this.enable();
        }
        disable() {
            t(this.Reveal.getSlidesElement(), ".fragment").forEach((e)=>{
                e.classList.add("visible"), e.classList.remove("current-fragment");
            });
        }
        enable() {
            t(this.Reveal.getSlidesElement(), ".fragment").forEach((e)=>{
                e.classList.remove("visible"), e.classList.remove("current-fragment");
            });
        }
        availableRoutes() {
            let e = this.Reveal.getCurrentSlide();
            if (e && this.Reveal.getConfig().fragments) {
                let t = e.querySelectorAll(".fragment:not(.disabled)"), i = e.querySelectorAll(".fragment:not(.disabled):not(.visible)");
                return {
                    prev: t.length - i.length > 0,
                    next: !!i.length
                };
            }
            return {
                prev: !1,
                next: !1
            };
        }
        sort(e, t = !1) {
            e = Array.from(e);
            let i = [], s = [], a = [];
            e.forEach((e)=>{
                if (e.hasAttribute("data-fragment-index")) {
                    let t = parseInt(e.getAttribute("data-fragment-index"), 10);
                    i[t] || (i[t] = []), i[t].push(e);
                } else s.push([
                    e
                ]);
            }), i = i.concat(s);
            let n = 0;
            return i.forEach((e)=>{
                e.forEach((e)=>{
                    a.push(e), e.setAttribute("data-fragment-index", n);
                }), n++;
            }), !0 === t ? i : a;
        }
        sortAll() {
            this.Reveal.getHorizontalSlides().forEach((e)=>{
                let i = t(e, "section");
                i.forEach((e, t)=>{
                    this.sort(e.querySelectorAll(".fragment"));
                }, this), 0 === i.length && this.sort(e.querySelectorAll(".fragment"));
            });
        }
        update(e, t, i = this.Reveal.getCurrentSlide()) {
            let s = {
                shown: [],
                hidden: []
            };
            if (i && this.Reveal.getConfig().fragments && (t = t || this.sort(i.querySelectorAll(".fragment"))).length) {
                let a = 0;
                if ("number" != typeof e) {
                    let t = this.sort(i.querySelectorAll(".fragment.visible")).pop();
                    t && (e = parseInt(t.getAttribute("data-fragment-index") || 0, 10));
                }
                Array.from(t).forEach((t, i)=>{
                    if (t.hasAttribute("data-fragment-index") && (i = parseInt(t.getAttribute("data-fragment-index"), 10)), a = Math.max(a, i), i <= e) {
                        let a = t.classList.contains("visible");
                        t.classList.add("visible"), t.classList.remove("current-fragment"), i === e && (this.Reveal.announceStatus(this.Reveal.getStatusText(t)), t.classList.add("current-fragment"), this.Reveal.slideContent.startEmbeddedContent(t)), a || (s.shown.push(t), this.Reveal.dispatchEvent({
                            target: t,
                            type: "visible",
                            bubbles: !1
                        }));
                    } else {
                        let e = t.classList.contains("visible");
                        t.classList.remove("visible"), t.classList.remove("current-fragment"), e && (this.Reveal.slideContent.stopEmbeddedContent(t), s.hidden.push(t), this.Reveal.dispatchEvent({
                            target: t,
                            type: "hidden",
                            bubbles: !1
                        }));
                    }
                }), e = "number" == typeof e ? e : -1, e = Math.max(Math.min(e, a), -1), i.setAttribute("data-fragment", e);
            }
            return s;
        }
        sync(e = this.Reveal.getCurrentSlide()) {
            return this.sort(e.querySelectorAll(".fragment"));
        }
        goto(e, t = 0) {
            let i = this.Reveal.getCurrentSlide();
            if (i && this.Reveal.getConfig().fragments) {
                let s = this.sort(i.querySelectorAll(".fragment:not(.disabled)"));
                if (s.length) {
                    if ("number" != typeof e) {
                        let t = this.sort(i.querySelectorAll(".fragment:not(.disabled).visible")).pop();
                        e = t ? parseInt(t.getAttribute("data-fragment-index") || 0, 10) : -1;
                    }
                    e += t;
                    let a = this.update(e, s);
                    return a.hidden.length && this.Reveal.dispatchEvent({
                        type: "fragmenthidden",
                        data: {
                            fragment: a.hidden[0],
                            fragments: a.hidden
                        }
                    }), a.shown.length && this.Reveal.dispatchEvent({
                        type: "fragmentshown",
                        data: {
                            fragment: a.shown[0],
                            fragments: a.shown
                        }
                    }), this.Reveal.controls.update(), this.Reveal.progress.update(), this.Reveal.getConfig().fragmentInURL && this.Reveal.location.writeURL(), !(!a.shown.length && !a.hidden.length);
                }
            }
            return !1;
        }
        next() {
            return this.goto(null, 1);
        }
        prev() {
            return this.goto(null, -1);
        }
    }
    class P {
        constructor(e){
            this.Reveal = e, this.active = !1, this.onSlideClicked = this.onSlideClicked.bind(this);
        }
        activate() {
            if (this.Reveal.getConfig().overview && !this.Reveal.isScrollView() && !this.isActive()) {
                this.active = !0, this.Reveal.getRevealElement().classList.add("overview"), this.Reveal.cancelAutoSlide(), this.Reveal.getSlidesElement().appendChild(this.Reveal.getBackgroundsElement()), t(this.Reveal.getRevealElement(), b).forEach((e)=>{
                    e.classList.contains("stack") || e.addEventListener("click", this.onSlideClicked, !0);
                });
                const e = 70, i = this.Reveal.getComputedSlideSize();
                this.overviewSlideWidth = i.width + e, this.overviewSlideHeight = i.height + e, this.Reveal.getConfig().rtl && (this.overviewSlideWidth = -this.overviewSlideWidth), this.Reveal.updateSlidesVisibility(), this.layout(), this.update(), this.Reveal.layout();
                const s = this.Reveal.getIndices();
                this.Reveal.dispatchEvent({
                    type: "overviewshown",
                    data: {
                        indexh: s.h,
                        indexv: s.v,
                        currentSlide: this.Reveal.getCurrentSlide()
                    }
                });
            }
        }
        layout() {
            this.Reveal.getHorizontalSlides().forEach((e, i)=>{
                e.setAttribute("data-index-h", i), a(e, "translate3d(" + i * this.overviewSlideWidth + "px, 0, 0)"), e.classList.contains("stack") && t(e, "section").forEach((e, t)=>{
                    e.setAttribute("data-index-h", i), e.setAttribute("data-index-v", t), a(e, "translate3d(0, " + t * this.overviewSlideHeight + "px, 0)");
                });
            }), Array.from(this.Reveal.getBackgroundsElement().childNodes).forEach((e, i)=>{
                a(e, "translate3d(" + i * this.overviewSlideWidth + "px, 0, 0)"), t(e, ".slide-background").forEach((e, t)=>{
                    a(e, "translate3d(0, " + t * this.overviewSlideHeight + "px, 0)");
                });
            });
        }
        update() {
            const e = Math.min(window.innerWidth, window.innerHeight), t = Math.max(e / 5, 150) / e, i = this.Reveal.getIndices();
            this.Reveal.transformSlides({
                overview: [
                    "scale(" + t + ")",
                    "translateX(" + -i.h * this.overviewSlideWidth + "px)",
                    "translateY(" + -i.v * this.overviewSlideHeight + "px)"
                ].join(" ")
            });
        }
        deactivate() {
            if (this.Reveal.getConfig().overview) {
                this.active = !1, this.Reveal.getRevealElement().classList.remove("overview"), this.Reveal.getRevealElement().classList.add("overview-deactivating"), setTimeout(()=>{
                    this.Reveal.getRevealElement().classList.remove("overview-deactivating");
                }, 1), this.Reveal.getRevealElement().appendChild(this.Reveal.getBackgroundsElement()), t(this.Reveal.getRevealElement(), b).forEach((e)=>{
                    a(e, ""), e.removeEventListener("click", this.onSlideClicked, !0);
                }), t(this.Reveal.getBackgroundsElement(), ".slide-background").forEach((e)=>{
                    a(e, "");
                }), this.Reveal.transformSlides({
                    overview: ""
                });
                const e = this.Reveal.getIndices();
                this.Reveal.slide(e.h, e.v), this.Reveal.layout(), this.Reveal.cueAutoSlide(), this.Reveal.dispatchEvent({
                    type: "overviewhidden",
                    data: {
                        indexh: e.h,
                        indexv: e.v,
                        currentSlide: this.Reveal.getCurrentSlide()
                    }
                });
            }
        }
        toggle(e) {
            "boolean" == typeof e ? e ? this.activate() : this.deactivate() : this.isActive() ? this.deactivate() : this.activate();
        }
        isActive() {
            return this.active;
        }
        onSlideClicked(e) {
            if (this.isActive()) {
                e.preventDefault();
                let t = e.target;
                for(; t && !t.nodeName.match(/section/gi);)t = t.parentNode;
                if (t && !t.classList.contains("disabled") && (this.deactivate(), t.nodeName.match(/section/gi))) {
                    let e = parseInt(t.getAttribute("data-index-h"), 10), i = parseInt(t.getAttribute("data-index-v"), 10);
                    this.Reveal.slide(e, i);
                }
            }
        }
    }
    class T {
        constructor(e){
            this.Reveal = e, this.shortcuts = {}, this.bindings = {}, this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        }
        configure(e, t) {
            "linear" === e.navigationMode ? (this.shortcuts["&#8594;  ,  &#8595;  ,  SPACE  ,  N  ,  L  ,  J"] = "Next slide", this.shortcuts["&#8592;  ,  &#8593;  ,  P  ,  H  ,  K"] = "Previous slide") : (this.shortcuts["N  ,  SPACE"] = "Next slide", this.shortcuts["P  ,  Shift SPACE"] = "Previous slide", this.shortcuts["&#8592;  ,  H"] = "Navigate left", this.shortcuts["&#8594;  ,  L"] = "Navigate right", this.shortcuts["&#8593;  ,  K"] = "Navigate up", this.shortcuts["&#8595;  ,  J"] = "Navigate down"), this.shortcuts["Alt + &#8592;/&#8593/&#8594;/&#8595;"] = "Navigate without fragments", this.shortcuts["Shift + &#8592;/&#8593/&#8594;/&#8595;"] = "Jump to first/last slide", this.shortcuts["B  ,  ."] = "Pause", this.shortcuts.F = "Fullscreen", this.shortcuts.G = "Jump to slide", this.shortcuts["ESC, O"] = "Slide overview";
        }
        bind() {
            document.addEventListener("keydown", this.onDocumentKeyDown, !1);
        }
        unbind() {
            document.removeEventListener("keydown", this.onDocumentKeyDown, !1);
        }
        addKeyBinding(e, t) {
            "object" == typeof e && e.keyCode ? this.bindings[e.keyCode] = {
                callback: t,
                key: e.key,
                description: e.description
            } : this.bindings[e] = {
                callback: t,
                key: null,
                description: null
            };
        }
        removeKeyBinding(e) {
            delete this.bindings[e];
        }
        triggerKey(e) {
            this.onDocumentKeyDown({
                keyCode: e
            });
        }
        registerKeyboardShortcut(e, t) {
            this.shortcuts[e] = t;
        }
        getShortcuts() {
            return this.shortcuts;
        }
        getBindings() {
            return this.bindings;
        }
        onDocumentKeyDown(e) {
            let t = this.Reveal.getConfig();
            if ("function" == typeof t.keyboardCondition && !1 === t.keyboardCondition(e)) return !0;
            if ("focused" === t.keyboardCondition && !this.Reveal.isFocused()) return !0;
            let i = e.keyCode, s = !this.Reveal.isAutoSliding();
            this.Reveal.onUserInput(e);
            let a = document.activeElement && !0 === document.activeElement.isContentEditable, n = document.activeElement && document.activeElement.tagName && /input|textarea/i.test(document.activeElement.tagName), r = document.activeElement && document.activeElement.className && /speaker-notes/i.test(document.activeElement.className), o = !(-1 !== [
                32,
                37,
                38,
                39,
                40,
                78,
                80,
                191
            ].indexOf(e.keyCode) && e.shiftKey || e.altKey) && (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey);
            if (a || n || r || o) return;
            let l, d = [
                66,
                86,
                190,
                191
            ];
            if ("object" == typeof t.keyboard) for(l in t.keyboard)"togglePause" === t.keyboard[l] && d.push(parseInt(l, 10));
            if (this.Reveal.isPaused() && -1 === d.indexOf(i)) return !1;
            let c = "linear" === t.navigationMode || !this.Reveal.hasHorizontalSlides() || !this.Reveal.hasVerticalSlides(), h = !1;
            if ("object" == typeof t.keyboard) {
                for(l in t.keyboard)if (parseInt(l, 10) === i) {
                    let i = t.keyboard[l];
                    "function" == typeof i ? i.apply(null, [
                        e
                    ]) : "string" == typeof i && "function" == typeof this.Reveal[i] && this.Reveal[i].call(), h = !0;
                }
            }
            if (!1 === h) {
                for(l in this.bindings)if (parseInt(l, 10) === i) {
                    let t = this.bindings[l].callback;
                    "function" == typeof t ? t.apply(null, [
                        e
                    ]) : "string" == typeof t && "function" == typeof this.Reveal[t] && this.Reveal[t].call(), h = !0;
                }
            }
            !1 === h && (h = !0, 80 === i || 33 === i ? this.Reveal.prev({
                skipFragments: e.altKey
            }) : 78 === i || 34 === i ? this.Reveal.next({
                skipFragments: e.altKey
            }) : 72 === i || 37 === i ? e.shiftKey ? this.Reveal.slide(0) : !this.Reveal.overview.isActive() && c ? this.Reveal.prev({
                skipFragments: e.altKey
            }) : this.Reveal.left({
                skipFragments: e.altKey
            }) : 76 === i || 39 === i ? e.shiftKey ? this.Reveal.slide(this.Reveal.getHorizontalSlides().length - 1) : !this.Reveal.overview.isActive() && c ? this.Reveal.next({
                skipFragments: e.altKey
            }) : this.Reveal.right({
                skipFragments: e.altKey
            }) : 75 === i || 38 === i ? e.shiftKey ? this.Reveal.slide(void 0, 0) : !this.Reveal.overview.isActive() && c ? this.Reveal.prev({
                skipFragments: e.altKey
            }) : this.Reveal.up({
                skipFragments: e.altKey
            }) : 74 === i || 40 === i ? e.shiftKey ? this.Reveal.slide(void 0, Number.MAX_VALUE) : !this.Reveal.overview.isActive() && c ? this.Reveal.next({
                skipFragments: e.altKey
            }) : this.Reveal.down({
                skipFragments: e.altKey
            }) : 36 === i ? this.Reveal.slide(0) : 35 === i ? this.Reveal.slide(this.Reveal.getHorizontalSlides().length - 1) : 32 === i ? (this.Reveal.overview.isActive() && this.Reveal.overview.deactivate(), e.shiftKey ? this.Reveal.prev({
                skipFragments: e.altKey
            }) : this.Reveal.next({
                skipFragments: e.altKey
            })) : [
                58,
                59,
                66,
                86,
                190
            ].includes(i) || 191 === i && !e.shiftKey ? this.Reveal.togglePause() : 70 === i ? ((e)=>{
                let t = (e = e || document.documentElement).requestFullscreen || e.webkitRequestFullscreen || e.webkitRequestFullScreen || e.mozRequestFullScreen || e.msRequestFullscreen;
                t && t.apply(e);
            })(t.embedded ? this.Reveal.getViewportElement() : document.documentElement) : 65 === i ? t.autoSlideStoppable && this.Reveal.toggleAutoSlide(s) : 71 === i ? t.jumpToSlide && this.Reveal.toggleJumpToSlide() : 191 === i && e.shiftKey ? this.Reveal.toggleHelp() : h = !1), h ? e.preventDefault && e.preventDefault() : 27 !== i && 79 !== i || (!1 === this.Reveal.closeOverlay() && this.Reveal.overview.toggle(), e.preventDefault && e.preventDefault()), this.Reveal.cueAutoSlide();
        }
    }
    class N {
        MAX_REPLACE_STATE_FREQUENCY = 1e3;
        constructor(e){
            this.Reveal = e, this.writeURLTimeout = 0, this.replaceStateTimestamp = 0, this.onWindowHashChange = this.onWindowHashChange.bind(this);
        }
        bind() {
            window.addEventListener("hashchange", this.onWindowHashChange, !1);
        }
        unbind() {
            window.removeEventListener("hashchange", this.onWindowHashChange, !1);
        }
        getIndicesFromHash(e = window.location.hash, t = {}) {
            let i = e.replace(/^#\/?/, ""), s = i.split("/");
            if (/^[0-9]*$/.test(s[0]) || !i.length) {
                const e = this.Reveal.getConfig();
                let i, a = e.hashOneBasedIndex || t.oneBasedIndex ? 1 : 0, n = parseInt(s[0], 10) - a || 0, r = parseInt(s[1], 10) - a || 0;
                return e.fragmentInURL && (i = parseInt(s[2], 10), isNaN(i) && (i = void 0)), {
                    h: n,
                    v: r,
                    f: i
                };
            }
            {
                let e, t;
                /\/[-\d]+$/g.test(i) && (t = parseInt(i.split("/").pop(), 10), t = isNaN(t) ? void 0 : t, i = i.split("/").shift());
                try {
                    e = document.getElementById(decodeURIComponent(i)).closest(".slides section");
                } catch (e) {}
                if (e) return {
                    ...this.Reveal.getIndices(e),
                    f: t
                };
            }
            return null;
        }
        readURL() {
            const e = this.Reveal.getIndices(), t = this.getIndicesFromHash();
            t ? t.h === e.h && t.v === e.v && void 0 === t.f || this.Reveal.slide(t.h, t.v, t.f) : this.Reveal.slide(e.h || 0, e.v || 0);
        }
        writeURL(e) {
            let t = this.Reveal.getConfig(), i = this.Reveal.getCurrentSlide();
            if (clearTimeout(this.writeURLTimeout), "number" == typeof e) this.writeURLTimeout = setTimeout(this.writeURL, e);
            else if (i) {
                let e = this.getHash();
                t.history ? window.location.hash = e : t.hash && ("/" === e ? this.debouncedReplaceState(window.location.pathname + window.location.search) : this.debouncedReplaceState("#" + e));
            }
        }
        replaceState(e) {
            window.history.replaceState(null, null, e), this.replaceStateTimestamp = Date.now();
        }
        debouncedReplaceState(e) {
            clearTimeout(this.replaceStateTimeout), Date.now() - this.replaceStateTimestamp > this.MAX_REPLACE_STATE_FREQUENCY ? this.replaceState(e) : this.replaceStateTimeout = setTimeout(()=>this.replaceState(e), this.MAX_REPLACE_STATE_FREQUENCY);
        }
        getHash(e) {
            let t = "/", i = e || this.Reveal.getCurrentSlide(), s = i ? i.getAttribute("id") : null;
            s && (s = encodeURIComponent(s));
            let a = this.Reveal.getIndices(e);
            if (this.Reveal.getConfig().fragmentInURL || (a.f = void 0), "string" == typeof s && s.length) t = "/" + s, a.f >= 0 && (t += "/" + a.f);
            else {
                let e = this.Reveal.getConfig().hashOneBasedIndex ? 1 : 0;
                (a.h > 0 || a.v > 0 || a.f >= 0) && (t += a.h + e), (a.v > 0 || a.f >= 0) && (t += "/" + (a.v + e)), a.f >= 0 && (t += "/" + a.f);
            }
            return t;
        }
        onWindowHashChange(e) {
            this.readURL();
        }
    }
    class M {
        constructor(e){
            this.Reveal = e, this.onNavigateLeftClicked = this.onNavigateLeftClicked.bind(this), this.onNavigateRightClicked = this.onNavigateRightClicked.bind(this), this.onNavigateUpClicked = this.onNavigateUpClicked.bind(this), this.onNavigateDownClicked = this.onNavigateDownClicked.bind(this), this.onNavigatePrevClicked = this.onNavigatePrevClicked.bind(this), this.onNavigateNextClicked = this.onNavigateNextClicked.bind(this);
        }
        render() {
            const e = this.Reveal.getConfig().rtl, i = this.Reveal.getRevealElement();
            this.element = document.createElement("aside"), this.element.className = "controls", this.element.innerHTML = `<button class="navigate-left" aria-label="${e ? "next slide" : "previous slide"}"><div class="controls-arrow"></div></button>\n\t\t\t<button class="navigate-right" aria-label="${e ? "previous slide" : "next slide"}"><div class="controls-arrow"></div></button>\n\t\t\t<button class="navigate-up" aria-label="above slide"><div class="controls-arrow"></div></button>\n\t\t\t<button class="navigate-down" aria-label="below slide"><div class="controls-arrow"></div></button>`, this.Reveal.getRevealElement().appendChild(this.element), this.controlsLeft = t(i, ".navigate-left"), this.controlsRight = t(i, ".navigate-right"), this.controlsUp = t(i, ".navigate-up"), this.controlsDown = t(i, ".navigate-down"), this.controlsPrev = t(i, ".navigate-prev"), this.controlsNext = t(i, ".navigate-next"), this.controlsRightArrow = this.element.querySelector(".navigate-right"), this.controlsLeftArrow = this.element.querySelector(".navigate-left"), this.controlsDownArrow = this.element.querySelector(".navigate-down");
        }
        configure(e, t) {
            this.element.style.display = e.controls ? "block" : "none", this.element.setAttribute("data-controls-layout", e.controlsLayout), this.element.setAttribute("data-controls-back-arrows", e.controlsBackArrows);
        }
        bind() {
            let e = [
                "touchstart",
                "click"
            ];
            u && (e = [
                "touchstart"
            ]), e.forEach((e)=>{
                this.controlsLeft.forEach((t)=>t.addEventListener(e, this.onNavigateLeftClicked, !1)), this.controlsRight.forEach((t)=>t.addEventListener(e, this.onNavigateRightClicked, !1)), this.controlsUp.forEach((t)=>t.addEventListener(e, this.onNavigateUpClicked, !1)), this.controlsDown.forEach((t)=>t.addEventListener(e, this.onNavigateDownClicked, !1)), this.controlsPrev.forEach((t)=>t.addEventListener(e, this.onNavigatePrevClicked, !1)), this.controlsNext.forEach((t)=>t.addEventListener(e, this.onNavigateNextClicked, !1));
            });
        }
        unbind() {
            [
                "touchstart",
                "click"
            ].forEach((e)=>{
                this.controlsLeft.forEach((t)=>t.removeEventListener(e, this.onNavigateLeftClicked, !1)), this.controlsRight.forEach((t)=>t.removeEventListener(e, this.onNavigateRightClicked, !1)), this.controlsUp.forEach((t)=>t.removeEventListener(e, this.onNavigateUpClicked, !1)), this.controlsDown.forEach((t)=>t.removeEventListener(e, this.onNavigateDownClicked, !1)), this.controlsPrev.forEach((t)=>t.removeEventListener(e, this.onNavigatePrevClicked, !1)), this.controlsNext.forEach((t)=>t.removeEventListener(e, this.onNavigateNextClicked, !1));
            });
        }
        update() {
            let e = this.Reveal.availableRoutes();
            [
                ...this.controlsLeft,
                ...this.controlsRight,
                ...this.controlsUp,
                ...this.controlsDown,
                ...this.controlsPrev,
                ...this.controlsNext
            ].forEach((e)=>{
                e.classList.remove("enabled", "fragmented"), e.setAttribute("disabled", "disabled");
            }), e.left && this.controlsLeft.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            }), e.right && this.controlsRight.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            }), e.up && this.controlsUp.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            }), e.down && this.controlsDown.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            }), (e.left || e.up) && this.controlsPrev.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            }), (e.right || e.down) && this.controlsNext.forEach((e)=>{
                e.classList.add("enabled"), e.removeAttribute("disabled");
            });
            let t = this.Reveal.getCurrentSlide();
            if (t) {
                let e = this.Reveal.fragments.availableRoutes();
                e.prev && this.controlsPrev.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                }), e.next && this.controlsNext.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                }), this.Reveal.isVerticalSlide(t) ? (e.prev && this.controlsUp.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                }), e.next && this.controlsDown.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                })) : (e.prev && this.controlsLeft.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                }), e.next && this.controlsRight.forEach((e)=>{
                    e.classList.add("fragmented", "enabled"), e.removeAttribute("disabled");
                }));
            }
            if (this.Reveal.getConfig().controlsTutorial) {
                let t = this.Reveal.getIndices();
                !this.Reveal.hasNavigatedVertically() && e.down ? this.controlsDownArrow.classList.add("highlight") : (this.controlsDownArrow.classList.remove("highlight"), this.Reveal.getConfig().rtl ? !this.Reveal.hasNavigatedHorizontally() && e.left && 0 === t.v ? this.controlsLeftArrow.classList.add("highlight") : this.controlsLeftArrow.classList.remove("highlight") : !this.Reveal.hasNavigatedHorizontally() && e.right && 0 === t.v ? this.controlsRightArrow.classList.add("highlight") : this.controlsRightArrow.classList.remove("highlight"));
            }
        }
        destroy() {
            this.unbind(), this.element.remove();
        }
        onNavigateLeftClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), "linear" === this.Reveal.getConfig().navigationMode ? this.Reveal.prev() : this.Reveal.left();
        }
        onNavigateRightClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), "linear" === this.Reveal.getConfig().navigationMode ? this.Reveal.next() : this.Reveal.right();
        }
        onNavigateUpClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.up();
        }
        onNavigateDownClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.down();
        }
        onNavigatePrevClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.prev();
        }
        onNavigateNextClicked(e) {
            e.preventDefault(), this.Reveal.onUserInput(), this.Reveal.next();
        }
    }
    class I {
        constructor(e){
            this.Reveal = e, this.onProgressClicked = this.onProgressClicked.bind(this);
        }
        render() {
            this.element = document.createElement("div"), this.element.className = "progress", this.Reveal.getRevealElement().appendChild(this.element), this.bar = document.createElement("span"), this.element.appendChild(this.bar);
        }
        configure(e, t) {
            this.element.style.display = e.progress ? "block" : "none";
        }
        bind() {
            this.Reveal.getConfig().progress && this.element && this.element.addEventListener("click", this.onProgressClicked, !1);
        }
        unbind() {
            this.Reveal.getConfig().progress && this.element && this.element.removeEventListener("click", this.onProgressClicked, !1);
        }
        update() {
            if (this.Reveal.getConfig().progress && this.bar) {
                let e = this.Reveal.getProgress();
                this.Reveal.getTotalSlides() < 2 && (e = 0), this.bar.style.transform = "scaleX(" + e + ")";
            }
        }
        getMaxWidth() {
            return this.Reveal.getRevealElement().offsetWidth;
        }
        onProgressClicked(e) {
            this.Reveal.onUserInput(e), e.preventDefault();
            let t = this.Reveal.getSlides(), i = t.length, s = Math.floor(e.clientX / this.getMaxWidth() * i);
            this.Reveal.getConfig().rtl && (s = i - s);
            let a = this.Reveal.getIndices(t[s]);
            this.Reveal.slide(a.h, a.v);
        }
        destroy() {
            this.element.remove();
        }
    }
    class B {
        constructor(e){
            this.Reveal = e, this.lastMouseWheelStep = 0, this.cursorHidden = !1, this.cursorInactiveTimeout = 0, this.onDocumentCursorActive = this.onDocumentCursorActive.bind(this), this.onDocumentMouseScroll = this.onDocumentMouseScroll.bind(this);
        }
        configure(e, t) {
            e.mouseWheel ? document.addEventListener("wheel", this.onDocumentMouseScroll, !1) : document.removeEventListener("wheel", this.onDocumentMouseScroll, !1), e.hideInactiveCursor ? (document.addEventListener("mousemove", this.onDocumentCursorActive, !1), document.addEventListener("mousedown", this.onDocumentCursorActive, !1)) : (this.showCursor(), document.removeEventListener("mousemove", this.onDocumentCursorActive, !1), document.removeEventListener("mousedown", this.onDocumentCursorActive, !1));
        }
        showCursor() {
            this.cursorHidden && (this.cursorHidden = !1, this.Reveal.getRevealElement().style.cursor = "");
        }
        hideCursor() {
            !1 === this.cursorHidden && (this.cursorHidden = !0, this.Reveal.getRevealElement().style.cursor = "none");
        }
        destroy() {
            this.showCursor(), document.removeEventListener("wheel", this.onDocumentMouseScroll, !1), document.removeEventListener("mousemove", this.onDocumentCursorActive, !1), document.removeEventListener("mousedown", this.onDocumentCursorActive, !1);
        }
        onDocumentCursorActive(e) {
            this.showCursor(), clearTimeout(this.cursorInactiveTimeout), this.cursorInactiveTimeout = setTimeout(this.hideCursor.bind(this), this.Reveal.getConfig().hideCursorTime);
        }
        onDocumentMouseScroll(e) {
            if (Date.now() - this.lastMouseWheelStep > 1e3) {
                this.lastMouseWheelStep = Date.now();
                let t = e.detail || -e.wheelDelta;
                t > 0 ? this.Reveal.next() : t < 0 && this.Reveal.prev();
            }
        }
    }
    const H = (e, t)=>{
        const i = document.createElement("script");
        i.type = "text/javascript", i.async = !1, i.defer = !1, i.src = e, "function" == typeof t && (i.onload = i.onreadystatechange = (e)=>{
            ("load" === e.type || /loaded|complete/.test(i.readyState)) && (i.onload = i.onreadystatechange = i.onerror = null, t());
        }, i.onerror = (e)=>{
            i.onload = i.onreadystatechange = i.onerror = null, t(new Error("Failed loading script: " + i.src + "\n" + e));
        });
        const s = document.querySelector("head");
        s.insertBefore(i, s.lastChild);
    };
    class D {
        constructor(e){
            this.Reveal = e, this.state = "idle", this.registeredPlugins = {}, this.asyncDependencies = [];
        }
        load(e, t) {
            return this.state = "loading", e.forEach(this.registerPlugin.bind(this)), new Promise((e)=>{
                let i = [], s = 0;
                if (t.forEach((e)=>{
                    e.condition && !e.condition() || (e.async ? this.asyncDependencies.push(e) : i.push(e));
                }), i.length) {
                    s = i.length;
                    const t = (t)=>{
                        t && "function" == typeof t.callback && t.callback(), 0 == --s && this.initPlugins().then(e);
                    };
                    i.forEach((e)=>{
                        "string" == typeof e.id ? (this.registerPlugin(e), t(e)) : "string" == typeof e.src ? H(e.src, ()=>t(e)) : (console.warn("Unrecognized plugin format", e), t());
                    });
                } else this.initPlugins().then(e);
            });
        }
        initPlugins() {
            return new Promise((e)=>{
                let t = Object.values(this.registeredPlugins), i = t.length;
                if (0 === i) this.loadAsync().then(e);
                else {
                    let s, a = ()=>{
                        0 == --i ? this.loadAsync().then(e) : s();
                    }, n = 0;
                    s = ()=>{
                        let e = t[n++];
                        if ("function" == typeof e.init) {
                            let t = e.init(this.Reveal);
                            t && "function" == typeof t.then ? t.then(a) : a();
                        } else a();
                    }, s();
                }
            });
        }
        loadAsync() {
            return this.state = "loaded", this.asyncDependencies.length && this.asyncDependencies.forEach((e)=>{
                H(e.src, e.callback);
            }), Promise.resolve();
        }
        registerPlugin(e) {
            2 === arguments.length && "string" == typeof arguments[0] ? (e = arguments[1]).id = arguments[0] : "function" == typeof e && (e = e());
            let t = e.id;
            "string" != typeof t ? console.warn("Unrecognized plugin format; can't find plugin.id", e) : void 0 === this.registeredPlugins[t] ? (this.registeredPlugins[t] = e, "loaded" === this.state && "function" == typeof e.init && e.init(this.Reveal)) : console.warn('reveal.js: "' + t + '" plugin has already been registered');
        }
        hasPlugin(e) {
            return !!this.registeredPlugins[e];
        }
        getPlugin(e) {
            return this.registeredPlugins[e];
        }
        getRegisteredPlugins() {
            return this.registeredPlugins;
        }
        destroy() {
            Object.values(this.registeredPlugins).forEach((e)=>{
                "function" == typeof e.destroy && e.destroy();
            }), this.registeredPlugins = {}, this.asyncDependencies = [];
        }
    }
    class F {
        constructor(e){
            this.Reveal = e, this.touchStartX = 0, this.touchStartY = 0, this.touchStartCount = 0, this.touchCaptured = !1, this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onTouchStart = this.onTouchStart.bind(this), this.onTouchMove = this.onTouchMove.bind(this), this.onTouchEnd = this.onTouchEnd.bind(this);
        }
        bind() {
            let e = this.Reveal.getRevealElement();
            "onpointerdown" in window ? (e.addEventListener("pointerdown", this.onPointerDown, !1), e.addEventListener("pointermove", this.onPointerMove, !1), e.addEventListener("pointerup", this.onPointerUp, !1)) : window.navigator.msPointerEnabled ? (e.addEventListener("MSPointerDown", this.onPointerDown, !1), e.addEventListener("MSPointerMove", this.onPointerMove, !1), e.addEventListener("MSPointerUp", this.onPointerUp, !1)) : (e.addEventListener("touchstart", this.onTouchStart, !1), e.addEventListener("touchmove", this.onTouchMove, !1), e.addEventListener("touchend", this.onTouchEnd, !1));
        }
        unbind() {
            let e = this.Reveal.getRevealElement();
            e.removeEventListener("pointerdown", this.onPointerDown, !1), e.removeEventListener("pointermove", this.onPointerMove, !1), e.removeEventListener("pointerup", this.onPointerUp, !1), e.removeEventListener("MSPointerDown", this.onPointerDown, !1), e.removeEventListener("MSPointerMove", this.onPointerMove, !1), e.removeEventListener("MSPointerUp", this.onPointerUp, !1), e.removeEventListener("touchstart", this.onTouchStart, !1), e.removeEventListener("touchmove", this.onTouchMove, !1), e.removeEventListener("touchend", this.onTouchEnd, !1);
        }
        isSwipePrevented(e) {
            if (n(e, "video, audio")) return !0;
            for(; e && "function" == typeof e.hasAttribute;){
                if (e.hasAttribute("data-prevent-swipe")) return !0;
                e = e.parentNode;
            }
            return !1;
        }
        onTouchStart(e) {
            if (this.isSwipePrevented(e.target)) return !0;
            this.touchStartX = e.touches[0].clientX, this.touchStartY = e.touches[0].clientY, this.touchStartCount = e.touches.length;
        }
        onTouchMove(e) {
            if (this.isSwipePrevented(e.target)) return !0;
            let t = this.Reveal.getConfig();
            if (this.touchCaptured) u && e.preventDefault();
            else {
                this.Reveal.onUserInput(e);
                let i = e.touches[0].clientX, s = e.touches[0].clientY;
                if (1 === e.touches.length && 2 !== this.touchStartCount) {
                    let a = this.Reveal.availableRoutes({
                        includeFragments: !0
                    }), n = i - this.touchStartX, r = s - this.touchStartY;
                    n > 40 && Math.abs(n) > Math.abs(r) ? (this.touchCaptured = !0, "linear" === t.navigationMode ? t.rtl ? this.Reveal.next() : this.Reveal.prev() : this.Reveal.left()) : n < -40 && Math.abs(n) > Math.abs(r) ? (this.touchCaptured = !0, "linear" === t.navigationMode ? t.rtl ? this.Reveal.prev() : this.Reveal.next() : this.Reveal.right()) : r > 40 && a.up ? (this.touchCaptured = !0, "linear" === t.navigationMode ? this.Reveal.prev() : this.Reveal.up()) : r < -40 && a.down && (this.touchCaptured = !0, "linear" === t.navigationMode ? this.Reveal.next() : this.Reveal.down()), t.embedded ? (this.touchCaptured || this.Reveal.isVerticalSlide()) && e.preventDefault() : e.preventDefault();
                }
            }
        }
        onTouchEnd(e) {
            this.touchCaptured = !1;
        }
        onPointerDown(e) {
            e.pointerType !== e.MSPOINTER_TYPE_TOUCH && "touch" !== e.pointerType || (e.touches = [
                {
                    clientX: e.clientX,
                    clientY: e.clientY
                }
            ], this.onTouchStart(e));
        }
        onPointerMove(e) {
            e.pointerType !== e.MSPOINTER_TYPE_TOUCH && "touch" !== e.pointerType || (e.touches = [
                {
                    clientX: e.clientX,
                    clientY: e.clientY
                }
            ], this.onTouchMove(e));
        }
        onPointerUp(e) {
            e.pointerType !== e.MSPOINTER_TYPE_TOUCH && "touch" !== e.pointerType || (e.touches = [
                {
                    clientX: e.clientX,
                    clientY: e.clientY
                }
            ], this.onTouchEnd(e));
        }
    }
    const z = "focus", q = "blur";
    class O {
        constructor(e){
            this.Reveal = e, this.onRevealPointerDown = this.onRevealPointerDown.bind(this), this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        }
        configure(e, t) {
            e.embedded ? this.blur() : (this.focus(), this.unbind());
        }
        bind() {
            this.Reveal.getConfig().embedded && this.Reveal.getRevealElement().addEventListener("pointerdown", this.onRevealPointerDown, !1);
        }
        unbind() {
            this.Reveal.getRevealElement().removeEventListener("pointerdown", this.onRevealPointerDown, !1), document.removeEventListener("pointerdown", this.onDocumentPointerDown, !1);
        }
        focus() {
            this.state !== z && (this.Reveal.getRevealElement().classList.add("focused"), document.addEventListener("pointerdown", this.onDocumentPointerDown, !1)), this.state = z;
        }
        blur() {
            this.state !== q && (this.Reveal.getRevealElement().classList.remove("focused"), document.removeEventListener("pointerdown", this.onDocumentPointerDown, !1)), this.state = q;
        }
        isFocused() {
            return this.state === z;
        }
        destroy() {
            this.Reveal.getRevealElement().classList.remove("focused");
        }
        onRevealPointerDown(e) {
            this.focus();
        }
        onDocumentPointerDown(e) {
            let t = r(e.target, ".reveal");
            t && t === this.Reveal.getRevealElement() || this.blur();
        }
    }
    class W {
        constructor(e){
            this.Reveal = e;
        }
        render() {
            this.element = document.createElement("div"), this.element.className = "speaker-notes", this.element.setAttribute("data-prevent-swipe", ""), this.element.setAttribute("tabindex", "0"), this.Reveal.getRevealElement().appendChild(this.element);
        }
        configure(e, t) {
            e.showNotes && this.element.setAttribute("data-layout", "string" == typeof e.showNotes ? e.showNotes : "inline");
        }
        update() {
            this.Reveal.getConfig().showNotes && this.element && this.Reveal.getCurrentSlide() && !this.Reveal.isScrollView() && !this.Reveal.isPrintView() && (this.element.innerHTML = this.getSlideNotes() || '<span class="notes-placeholder">No notes on this slide.</span>');
        }
        updateVisibility() {
            this.Reveal.getConfig().showNotes && this.hasNotes() && !this.Reveal.isScrollView() && !this.Reveal.isPrintView() ? this.Reveal.getRevealElement().classList.add("show-notes") : this.Reveal.getRevealElement().classList.remove("show-notes");
        }
        hasNotes() {
            return this.Reveal.getSlidesElement().querySelectorAll("[data-notes], aside.notes").length > 0;
        }
        isSpeakerNotesWindow() {
            return !!window.location.search.match(/receiver/gi);
        }
        getSlideNotes(e = this.Reveal.getCurrentSlide()) {
            if (e.hasAttribute("data-notes")) return e.getAttribute("data-notes");
            let t = e.querySelectorAll("aside.notes");
            return t ? Array.from(t).map((e)=>e.innerHTML).join("\n") : null;
        }
        destroy() {
            this.element.remove();
        }
    }
    class U {
        constructor(e, t){
            this.diameter = 100, this.diameter2 = this.diameter / 2, this.thickness = 6, this.playing = !1, this.progress = 0, this.progressOffset = 1, this.container = e, this.progressCheck = t, this.canvas = document.createElement("canvas"), this.canvas.className = "playback", this.canvas.width = this.diameter, this.canvas.height = this.diameter, this.canvas.style.width = this.diameter2 + "px", this.canvas.style.height = this.diameter2 + "px", this.context = this.canvas.getContext("2d"), this.container.appendChild(this.canvas), this.render();
        }
        setPlaying(e) {
            const t = this.playing;
            this.playing = e, !t && this.playing ? this.animate() : this.render();
        }
        animate() {
            const e = this.progress;
            this.progress = this.progressCheck(), e > .8 && this.progress < .2 && (this.progressOffset = this.progress), this.render(), this.playing && requestAnimationFrame(this.animate.bind(this));
        }
        render() {
            let e = this.playing ? this.progress : 0, t = this.diameter2 - this.thickness, i = this.diameter2, s = this.diameter2, a = 28;
            this.progressOffset += .1 * (1 - this.progressOffset);
            const n = -Math.PI / 2 + e * (2 * Math.PI), r = -Math.PI / 2 + this.progressOffset * (2 * Math.PI);
            this.context.save(), this.context.clearRect(0, 0, this.diameter, this.diameter), this.context.beginPath(), this.context.arc(i, s, t + 4, 0, 2 * Math.PI, !1), this.context.fillStyle = "rgba( 0, 0, 0, 0.4 )", this.context.fill(), this.context.beginPath(), this.context.arc(i, s, t, 0, 2 * Math.PI, !1), this.context.lineWidth = this.thickness, this.context.strokeStyle = "rgba( 255, 255, 255, 0.2 )", this.context.stroke(), this.playing && (this.context.beginPath(), this.context.arc(i, s, t, r, n, !1), this.context.lineWidth = this.thickness, this.context.strokeStyle = "#fff", this.context.stroke()), this.context.translate(i - 14, s - 14), this.playing ? (this.context.fillStyle = "#fff", this.context.fillRect(0, 0, 10, a), this.context.fillRect(18, 0, 10, a)) : (this.context.beginPath(), this.context.translate(4, 0), this.context.moveTo(0, 0), this.context.lineTo(24, 14), this.context.lineTo(0, a), this.context.fillStyle = "#fff", this.context.fill()), this.context.restore();
        }
        on(e, t) {
            this.canvas.addEventListener(e, t, !1);
        }
        off(e, t) {
            this.canvas.removeEventListener(e, t, !1);
        }
        destroy() {
            this.playing = !1, this.canvas.parentNode && this.container.removeChild(this.canvas);
        }
    }
    var V = {
        width: 960,
        height: 700,
        margin: .04,
        minScale: .2,
        maxScale: 2,
        controls: !0,
        controlsTutorial: !0,
        controlsLayout: "bottom-right",
        controlsBackArrows: "faded",
        progress: !0,
        slideNumber: !1,
        showSlideNumber: "all",
        hashOneBasedIndex: !1,
        hash: !1,
        respondToHashChanges: !0,
        jumpToSlide: !0,
        history: !1,
        keyboard: !0,
        keyboardCondition: null,
        disableLayout: !1,
        overview: !0,
        center: !0,
        touch: !0,
        loop: !1,
        rtl: !1,
        navigationMode: "default",
        shuffle: !1,
        fragments: !0,
        fragmentInURL: !0,
        embedded: !1,
        help: !0,
        pause: !0,
        showNotes: !1,
        showHiddenSlides: !1,
        autoPlayMedia: null,
        preloadIframes: null,
        autoAnimate: !0,
        autoAnimateMatcher: null,
        autoAnimateEasing: "ease",
        autoAnimateDuration: 1,
        autoAnimateUnmatched: !0,
        autoAnimateStyles: [
            "opacity",
            "color",
            "background-color",
            "padding",
            "font-size",
            "line-height",
            "letter-spacing",
            "border-width",
            "border-color",
            "border-radius",
            "outline",
            "outline-offset"
        ],
        autoSlide: 0,
        autoSlideStoppable: !0,
        autoSlideMethod: null,
        defaultTiming: null,
        mouseWheel: !1,
        previewLinks: !1,
        postMessage: !0,
        postMessageEvents: !1,
        focusBodyOnPageVisibilityChange: !0,
        transition: "slide",
        transitionSpeed: "default",
        backgroundTransition: "fade",
        parallaxBackgroundImage: "",
        parallaxBackgroundSize: "",
        parallaxBackgroundRepeat: "",
        parallaxBackgroundPosition: "",
        parallaxBackgroundHorizontal: null,
        parallaxBackgroundVertical: null,
        view: null,
        scrollLayout: "full",
        scrollSnap: "mandatory",
        scrollProgress: "auto",
        scrollActivationWidth: 435,
        pdfMaxPagesPerSlide: Number.POSITIVE_INFINITY,
        pdfSeparateFragments: !0,
        pdfPageHeightOffset: -1,
        viewDistance: 3,
        mobileViewDistance: 2,
        display: "block",
        hideInactiveCursor: !0,
        hideCursorTime: 5e3,
        sortFragmentsOnSync: !0,
        dependencies: [],
        plugins: []
    };
    const j = "5.0.1";
    function K(n, o) {
        arguments.length < 2 && (o = arguments[0], n = document.querySelector(".reveal"));
        const d = {};
        let c, u, g, f, A, R = {}, H = !1, z = {
            hasNavigatedHorizontally: !1,
            hasNavigatedVertically: !1
        }, q = [], K = 1, $ = {
            layout: "",
            overview: ""
        }, X = {}, Y = "idle", _ = 0, J = 0, G = -1, Q = !1, Z = new p(d), ee = new v(d), te = new m(d), ie = new k(d), se = new y(d), ae = new L(d), ne = new C(d), re = new x(d), oe = new P(d), le = new T(d), de = new N(d), ce = new M(d), he = new I(d), ue = new B(d), ge = new D(d), pe = new O(d), ve = new F(d), me = new W(d);
        function fe() {
            H = !0, R.showHiddenSlides || t(X.wrapper, 'section[data-visibility="hidden"]').forEach((e)=>{
                const t = e.parentNode;
                1 === t.childElementCount && /section/i.test(t.nodeName) ? t.remove() : e.remove();
            }), function() {
                X.slides.classList.add("no-transition"), h ? X.wrapper.classList.add("no-hover") : X.wrapper.classList.remove("no-hover");
                se.render(), ee.render(), te.render(), ce.render(), he.render(), me.render(), X.pauseOverlay = ((e, t, i, s = "")=>{
                    let a = e.querySelectorAll("." + i);
                    for(let t = 0; t < a.length; t++){
                        let i = a[t];
                        if (i.parentNode === e) return i;
                    }
                    let n = document.createElement(t);
                    return n.className = i, n.innerHTML = s, e.appendChild(n), n;
                })(X.wrapper, "div", "pause-overlay", R.controls ? '<button class="resume-button">Resume presentation</button>' : null), X.statusElement = function() {
                    let e = X.wrapper.querySelector(".aria-status");
                    e || (e = document.createElement("div"), e.style.position = "absolute", e.style.height = "1px", e.style.width = "1px", e.style.overflow = "hidden", e.style.clip = "rect( 1px, 1px, 1px, 1px )", e.classList.add("aria-status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), X.wrapper.appendChild(e));
                    return e;
                }(), X.wrapper.setAttribute("role", "application");
            }(), R.postMessage && window.addEventListener("message", St, !1), setInterval(()=>{
                (!ae.isActive() && 0 !== X.wrapper.scrollTop || 0 !== X.wrapper.scrollLeft) && (X.wrapper.scrollTop = 0, X.wrapper.scrollLeft = 0);
            }, 1e3), document.addEventListener("fullscreenchange", Ct), document.addEventListener("webkitfullscreenchange", Ct), nt().forEach((e)=>{
                t(e, "section").forEach((e, t)=>{
                    t > 0 && (e.classList.remove("present"), e.classList.remove("past"), e.classList.add("future"), e.setAttribute("aria-hidden", "true"));
                });
            }), we(), se.update(!0), function() {
                const e = "print" === R.view, t = "scroll" === R.view || "reader" === R.view;
                (e || t) && (e ? Se() : ve.unbind(), X.viewport.classList.add("loading-scroll-mode"), e ? "complete" === document.readyState ? ne.activate() : window.addEventListener("load", ()=>ne.activate()) : ae.activate());
            }(), de.readURL(), setTimeout(()=>{
                X.slides.classList.remove("no-transition"), X.wrapper.classList.add("ready"), Le({
                    type: "ready",
                    data: {
                        indexh: c,
                        indexv: u,
                        currentSlide: f
                    }
                });
            }, 1);
        }
        function ye(e) {
            X.statusElement.textContent = e;
        }
        function be(e) {
            let t = "";
            if (3 === e.nodeType) t += e.textContent;
            else if (1 === e.nodeType) {
                let i = e.getAttribute("aria-hidden"), s = "none" === window.getComputedStyle(e).display;
                "true" === i || s || Array.from(e.childNodes).forEach((e)=>{
                    t += be(e);
                });
            }
            return t = t.trim(), "" === t ? "" : t + " ";
        }
        function we(t) {
            const s = {
                ...R
            };
            if ("object" == typeof t && e(R, t), !1 === d.isReady()) return;
            const a = X.wrapper.querySelectorAll(b).length;
            X.wrapper.classList.remove(s.transition), X.wrapper.classList.add(R.transition), X.wrapper.setAttribute("data-transition-speed", R.transitionSpeed), X.wrapper.setAttribute("data-background-transition", R.backgroundTransition), X.viewport.style.setProperty("--slide-width", "string" == typeof R.width ? R.width : R.width + "px"), X.viewport.style.setProperty("--slide-height", "string" == typeof R.height ? R.height : R.height + "px"), R.shuffle && Je(), i(X.wrapper, "embedded", R.embedded), i(X.wrapper, "rtl", R.rtl), i(X.wrapper, "center", R.center), !1 === R.pause && je(), R.previewLinks ? (Pe(), Te("[data-preview-link=false]")) : (Te(), Pe("[data-preview-link]:not([data-preview-link=false])")), ie.reset(), A && (A.destroy(), A = null), a > 1 && R.autoSlide && R.autoSlideStoppable && (A = new U(X.wrapper, ()=>Math.min(Math.max((Date.now() - G) / _, 0), 1)), A.on("click", Pt), Q = !1), "default" !== R.navigationMode ? X.wrapper.setAttribute("data-navigation-mode", R.navigationMode) : X.wrapper.removeAttribute("data-navigation-mode"), me.configure(R, s), pe.configure(R, s), ue.configure(R, s), ce.configure(R, s), he.configure(R, s), le.configure(R, s), re.configure(R, s), ee.configure(R, s), _e();
        }
        function Ee() {
            window.addEventListener("resize", kt, !1), R.touch && ve.bind(), R.keyboard && le.bind(), R.progress && he.bind(), R.respondToHashChanges && de.bind(), ce.bind(), pe.bind(), X.slides.addEventListener("click", Rt, !1), X.slides.addEventListener("transitionend", At, !1), X.pauseOverlay.addEventListener("click", je, !1), R.focusBodyOnPageVisibilityChange && document.addEventListener("visibilitychange", Lt, !1);
        }
        function Se() {
            ve.unbind(), pe.unbind(), le.unbind(), ce.unbind(), he.unbind(), de.unbind(), window.removeEventListener("resize", kt, !1), X.slides.removeEventListener("click", Rt, !1), X.slides.removeEventListener("transitionend", At, !1), X.pauseOverlay.removeEventListener("click", je, !1);
        }
        function Ae(e, t, i) {
            n.addEventListener(e, t, i);
        }
        function Re(e, t, i) {
            n.removeEventListener(e, t, i);
        }
        function ke(e) {
            "string" == typeof e.layout && ($.layout = e.layout), "string" == typeof e.overview && ($.overview = e.overview), $.layout ? a(X.slides, $.layout + " " + $.overview) : a(X.slides, $.overview);
        }
        function Le({ target: t = X.wrapper, type: i, data: s, bubbles: a = !0 }) {
            let n = document.createEvent("HTMLEvents", 1, 2);
            return n.initEvent(i, a, !0), e(n, s), t.dispatchEvent(n), t === X.wrapper && xe(i), n;
        }
        function Ce(e) {
            Le({
                type: "slidechanged",
                data: {
                    indexh: c,
                    indexv: u,
                    previousSlide: g,
                    currentSlide: f,
                    origin: e
                }
            });
        }
        function xe(t, i) {
            if (R.postMessageEvents && window.parent !== window.self) {
                let s = {
                    namespace: "reveal",
                    eventName: t,
                    state: ht()
                };
                e(s, i), window.parent.postMessage(JSON.stringify(s), "*");
            }
        }
        function Pe(e = "a") {
            Array.from(X.wrapper.querySelectorAll(e)).forEach((e)=>{
                /^(http|www)/gi.test(e.getAttribute("href")) && e.addEventListener("click", xt, !1);
            });
        }
        function Te(e = "a") {
            Array.from(X.wrapper.querySelectorAll(e)).forEach((e)=>{
                /^(http|www)/gi.test(e.getAttribute("href")) && e.removeEventListener("click", xt, !1);
            });
        }
        function Ne(e) {
            Ie(), X.overlay = document.createElement("div"), X.overlay.classList.add("overlay"), X.overlay.classList.add("overlay-preview"), X.wrapper.appendChild(X.overlay), X.overlay.innerHTML = `<header>\n\t\t\t\t<a class="close" href="#"><span class="icon"></span></a>\n\t\t\t\t<a class="external" href="${e}" target="_blank"><span class="icon"></span></a>\n\t\t\t</header>\n\t\t\t<div class="spinner"></div>\n\t\t\t<div class="viewport">\n\t\t\t\t<iframe src="${e}"></iframe>\n\t\t\t\t<small class="viewport-inner">\n\t\t\t\t\t<span class="x-frame-error">Unable to load iframe. This is likely due to the site's policy (x-frame-options).</span>\n\t\t\t\t</small>\n\t\t\t</div>`, X.overlay.querySelector("iframe").addEventListener("load", (e)=>{
                X.overlay.classList.add("loaded");
            }, !1), X.overlay.querySelector(".close").addEventListener("click", (e)=>{
                Ie(), e.preventDefault();
            }, !1), X.overlay.querySelector(".external").addEventListener("click", (e)=>{
                Ie();
            }, !1);
        }
        function Me() {
            if (R.help) {
                Ie(), X.overlay = document.createElement("div"), X.overlay.classList.add("overlay"), X.overlay.classList.add("overlay-help"), X.wrapper.appendChild(X.overlay);
                let e = '<p class="title">Keyboard Shortcuts</p><br/>', t = le.getShortcuts(), i = le.getBindings();
                e += "<table><th>KEY</th><th>ACTION</th>";
                for(let i in t)e += `<tr><td>${i}</td><td>${t[i]}</td></tr>`;
                for(let t in i)i[t].key && i[t].description && (e += `<tr><td>${i[t].key}</td><td>${i[t].description}</td></tr>`);
                e += "</table>", X.overlay.innerHTML = `\n\t\t\t\t<header>\n\t\t\t\t\t<a class="close" href="#"><span class="icon"></span></a>\n\t\t\t\t</header>\n\t\t\t\t<div class="viewport">\n\t\t\t\t\t<div class="viewport-inner">${e}</div>\n\t\t\t\t</div>\n\t\t\t`, X.overlay.querySelector(".close").addEventListener("click", (e)=>{
                    Ie(), e.preventDefault();
                }, !1);
            }
        }
        function Ie() {
            return !!X.overlay && (X.overlay.parentNode.removeChild(X.overlay), X.overlay = null, !0);
        }
        function Be() {
            if (X.wrapper && !ne.isActive()) {
                const e = X.viewport.offsetWidth, t = X.viewport.offsetHeight;
                if (!R.disableLayout) {
                    h && !R.embedded && document.documentElement.style.setProperty("--vh", .01 * window.innerHeight + "px");
                    const i = ae.isActive() ? De(e, t) : De(), s = K;
                    He(R.width, R.height), X.slides.style.width = i.width + "px", X.slides.style.height = i.height + "px", K = Math.min(i.presentationWidth / i.width, i.presentationHeight / i.height), K = Math.max(K, R.minScale), K = Math.min(K, R.maxScale), 1 === K || ae.isActive() ? (X.slides.style.zoom = "", X.slides.style.left = "", X.slides.style.top = "", X.slides.style.bottom = "", X.slides.style.right = "", ke({
                        layout: ""
                    })) : (X.slides.style.zoom = "", X.slides.style.left = "50%", X.slides.style.top = "50%", X.slides.style.bottom = "auto", X.slides.style.right = "auto", ke({
                        layout: "translate(-50%, -50%) scale(" + K + ")"
                    }));
                    const a = Array.from(X.wrapper.querySelectorAll(b));
                    for(let e = 0, t = a.length; e < t; e++){
                        const t = a[e];
                        "none" !== t.style.display && (R.center || t.classList.contains("center") ? t.classList.contains("stack") ? t.style.top = 0 : t.style.top = Math.max((i.height - t.scrollHeight) / 2, 0) + "px" : t.style.top = "");
                    }
                    s !== K && Le({
                        type: "resize",
                        data: {
                            oldScale: s,
                            scale: K,
                            size: i
                        }
                    }), "number" == typeof R.scrollActivationWidth && "scroll" !== R.view && (i.presentationWidth > 0 && i.presentationWidth <= R.scrollActivationWidth ? ae.isActive() || ae.activate() : ae.isActive() && ae.deactivate());
                }
                X.viewport.style.setProperty("--slide-scale", K), X.viewport.style.setProperty("--viewport-width", e + "px"), X.viewport.style.setProperty("--viewport-height", t + "px"), ae.layout(), he.update(), se.updateParallax(), oe.isActive() && oe.update();
            }
        }
        function He(e, i) {
            t(X.slides, "section > .stretch, section > .r-stretch").forEach((t)=>{
                let s = ((e, t = 0)=>{
                    if (e) {
                        let i, s = e.style.height;
                        return e.style.height = "0px", e.parentNode.style.height = "auto", i = t - e.parentNode.offsetHeight, e.style.height = s + "px", e.parentNode.style.removeProperty("height"), i;
                    }
                    return t;
                })(t, i);
                if (/(img|video)/gi.test(t.nodeName)) {
                    const i = t.naturalWidth || t.videoWidth, a = t.naturalHeight || t.videoHeight, n = Math.min(e / i, s / a);
                    t.style.width = i * n + "px", t.style.height = a * n + "px";
                } else t.style.width = e + "px", t.style.height = s + "px";
            });
        }
        function De(e, t) {
            let i = R.width, s = R.height;
            R.disableLayout && (i = X.slides.offsetWidth, s = X.slides.offsetHeight);
            const a = {
                width: i,
                height: s,
                presentationWidth: e || X.wrapper.offsetWidth,
                presentationHeight: t || X.wrapper.offsetHeight
            };
            return a.presentationWidth -= a.presentationWidth * R.margin, a.presentationHeight -= a.presentationHeight * R.margin, "string" == typeof a.width && /%$/.test(a.width) && (a.width = parseInt(a.width, 10) / 100 * a.presentationWidth), "string" == typeof a.height && /%$/.test(a.height) && (a.height = parseInt(a.height, 10) / 100 * a.presentationHeight), a;
        }
        function Fe(e, t) {
            "object" == typeof e && "function" == typeof e.setAttribute && e.setAttribute("data-previous-indexv", t || 0);
        }
        function ze(e) {
            if ("object" == typeof e && "function" == typeof e.setAttribute && e.classList.contains("stack")) {
                const t = e.hasAttribute("data-start-indexv") ? "data-start-indexv" : "data-previous-indexv";
                return parseInt(e.getAttribute(t) || 0, 10);
            }
            return 0;
        }
        function qe(e = f) {
            return e && e.parentNode && !!e.parentNode.nodeName.match(/section/i);
        }
        function Oe() {
            return !(!f || !qe(f)) && !f.nextElementSibling;
        }
        function We() {
            return 0 === c && 0 === u;
        }
        function Ue() {
            return !!f && !f.nextElementSibling && (!qe(f) || !f.parentNode.nextElementSibling);
        }
        function Ve() {
            if (R.pause) {
                const e = X.wrapper.classList.contains("paused");
                gt(), X.wrapper.classList.add("paused"), !1 === e && Le({
                    type: "paused"
                });
            }
        }
        function je() {
            const e = X.wrapper.classList.contains("paused");
            X.wrapper.classList.remove("paused"), ut(), e && Le({
                type: "resumed"
            });
        }
        function Ke(e) {
            "boolean" == typeof e ? e ? Ve() : je() : $e() ? je() : Ve();
        }
        function $e() {
            return X.wrapper.classList.contains("paused");
        }
        function Xe(e, i, s, a) {
            if (Le({
                type: "beforeslidechange",
                data: {
                    indexh: void 0 === e ? c : e,
                    indexv: void 0 === i ? u : i,
                    origin: a
                }
            }).defaultPrevented) return;
            g = f;
            const n = X.wrapper.querySelectorAll(w);
            if (ae.isActive()) {
                const t = ae.getSlideByIndices(e, i);
                return void (t && ae.scrollToSlide(t));
            }
            if (0 === n.length) return;
            void 0 !== i || oe.isActive() || (i = ze(n[e])), g && g.parentNode && g.parentNode.classList.contains("stack") && Fe(g.parentNode, u);
            const r = q.concat();
            q.length = 0;
            let o = c || 0, l = u || 0;
            c = Ge(w, void 0 === e ? c : e), u = Ge(E, void 0 === i ? u : i);
            let d = c !== o || u !== l;
            d || (g = null);
            let h = n[c], p = h.querySelectorAll("section");
            f = p[u] || h;
            let v = !1;
            d && g && f && !oe.isActive() && (Y = "running", v = Ye(g, f, o, l), v && X.slides.classList.add("disable-slide-transitions")), et(), Be(), oe.isActive() && oe.update(), void 0 !== s && re.goto(s), g && g !== f && (g.classList.remove("present"), g.setAttribute("aria-hidden", "true"), We() && setTimeout(()=>{
                t(X.wrapper, w + ".stack").forEach((e)=>{
                    Fe(e, 0);
                });
            }, 0));
            e: for(let e = 0, t = q.length; e < t; e++){
                for(let t = 0; t < r.length; t++)if (r[t] === q[e]) {
                    r.splice(t, 1);
                    continue e;
                }
                X.viewport.classList.add(q[e]), Le({
                    type: q[e]
                });
            }
            for(; r.length;)X.viewport.classList.remove(r.pop());
            d && Ce(a), !d && g || (Z.stopEmbeddedContent(g), Z.startEmbeddedContent(f)), requestAnimationFrame(()=>{
                ye(be(f));
            }), he.update(), ce.update(), me.update(), se.update(), se.updateParallax(), ee.update(), re.update(), de.writeURL(), ut(), v && (setTimeout(()=>{
                X.slides.classList.remove("disable-slide-transitions");
            }, 0), R.autoAnimate && ie.run(g, f));
        }
        function Ye(e, t, i, s) {
            return e.hasAttribute("data-auto-animate") && t.hasAttribute("data-auto-animate") && e.getAttribute("data-auto-animate-id") === t.getAttribute("data-auto-animate-id") && !(c > i || u > s ? t : e).hasAttribute("data-auto-animate-restart");
        }
        function _e() {
            Se(), Ee(), Be(), _ = R.autoSlide, ut(), se.create(), de.writeURL(), !0 === R.sortFragmentsOnSync && re.sortAll(), ce.update(), he.update(), et(), me.update(), me.updateVisibility(), se.update(!0), ee.update(), Z.formatEmbeddedContent(), !1 === R.autoPlayMedia ? Z.stopEmbeddedContent(f, {
                unloadIframes: !1
            }) : Z.startEmbeddedContent(f), oe.isActive() && oe.layout();
        }
        function Je(e = nt()) {
            e.forEach((t, i)=>{
                let s = e[Math.floor(Math.random() * e.length)];
                s.parentNode === t.parentNode && t.parentNode.insertBefore(t, s);
                let a = t.querySelectorAll("section");
                a.length && Je(a);
            });
        }
        function Ge(e, i) {
            let s = t(X.wrapper, e), a = s.length, n = ae.isActive() || ne.isActive(), r = !1, o = !1;
            if (a) {
                R.loop && (i >= a && (r = !0), (i %= a) < 0 && (i = a + i, o = !0)), i = Math.max(Math.min(i, a - 1), 0);
                for(let e = 0; e < a; e++){
                    let t = s[e], a = R.rtl && !qe(t);
                    t.classList.remove("past"), t.classList.remove("present"), t.classList.remove("future"), t.setAttribute("hidden", ""), t.setAttribute("aria-hidden", "true"), t.querySelector("section") && t.classList.add("stack"), n ? t.classList.add("present") : e < i ? (t.classList.add(a ? "future" : "past"), R.fragments && Qe(t)) : e > i ? (t.classList.add(a ? "past" : "future"), R.fragments && Ze(t)) : e === i && R.fragments && (r ? Ze(t) : o && Qe(t));
                }
                let e = s[i], t = e.classList.contains("present");
                e.classList.add("present"), e.removeAttribute("hidden"), e.removeAttribute("aria-hidden"), t || Le({
                    target: e,
                    type: "visible",
                    bubbles: !1
                });
                let l = e.getAttribute("data-state");
                l && (q = q.concat(l.split(" ")));
            } else i = 0;
            return i;
        }
        function Qe(e) {
            t(e, ".fragment").forEach((e)=>{
                e.classList.add("visible"), e.classList.remove("current-fragment");
            });
        }
        function Ze(e) {
            t(e, ".fragment.visible").forEach((e)=>{
                e.classList.remove("visible", "current-fragment");
            });
        }
        function et() {
            let e, i, s = nt(), a = s.length;
            if (a && void 0 !== c) {
                let n = oe.isActive() ? 10 : R.viewDistance;
                h && (n = oe.isActive() ? 6 : R.mobileViewDistance), ne.isActive() && (n = Number.MAX_VALUE);
                for(let r = 0; r < a; r++){
                    let o = s[r], l = t(o, "section"), d = l.length;
                    if (e = Math.abs((c || 0) - r) || 0, R.loop && (e = Math.abs(((c || 0) - r) % (a - n)) || 0), e < n ? Z.load(o) : Z.unload(o), d) {
                        let t = ze(o);
                        for(let s = 0; s < d; s++){
                            let a = l[s];
                            i = r === (c || 0) ? Math.abs((u || 0) - s) : Math.abs(s - t), e + i < n ? Z.load(a) : Z.unload(a);
                        }
                    }
                }
                lt() ? X.wrapper.classList.add("has-vertical-slides") : X.wrapper.classList.remove("has-vertical-slides"), ot() ? X.wrapper.classList.add("has-horizontal-slides") : X.wrapper.classList.remove("has-horizontal-slides");
            }
        }
        function tt({ includeFragments: e = !1 } = {}) {
            let t = X.wrapper.querySelectorAll(w), i = X.wrapper.querySelectorAll(E), s = {
                left: c > 0,
                right: c < t.length - 1,
                up: u > 0,
                down: u < i.length - 1
            };
            if (R.loop && (t.length > 1 && (s.left = !0, s.right = !0), i.length > 1 && (s.up = !0, s.down = !0)), t.length > 1 && "linear" === R.navigationMode && (s.right = s.right || s.down, s.left = s.left || s.up), !0 === e) {
                let e = re.availableRoutes();
                s.left = s.left || e.prev, s.up = s.up || e.prev, s.down = s.down || e.next, s.right = s.right || e.next;
            }
            if (R.rtl) {
                let e = s.left;
                s.left = s.right, s.right = e;
            }
            return s;
        }
        function it(e = f) {
            let t = nt(), i = 0;
            e: for(let s = 0; s < t.length; s++){
                let a = t[s], n = a.querySelectorAll("section");
                for(let t = 0; t < n.length; t++){
                    if (n[t] === e) break e;
                    "uncounted" !== n[t].dataset.visibility && i++;
                }
                if (a === e) break;
                !1 === a.classList.contains("stack") && "uncounted" !== a.dataset.visibility && i++;
            }
            return i;
        }
        function st(e) {
            let i, s = c, a = u;
            if (e) {
                if (ae.isActive()) s = parseInt(e.getAttribute("data-index-h"), 10), e.getAttribute("data-index-v") && (a = parseInt(e.getAttribute("data-index-v"), 10));
                else {
                    let i = qe(e), n = i ? e.parentNode : e, r = nt();
                    s = Math.max(r.indexOf(n), 0), a = void 0, i && (a = Math.max(t(e.parentNode, "section").indexOf(e), 0));
                }
            }
            if (!e && f) {
                if (f.querySelectorAll(".fragment").length > 0) {
                    let e = f.querySelector(".current-fragment");
                    i = e && e.hasAttribute("data-fragment-index") ? parseInt(e.getAttribute("data-fragment-index"), 10) : f.querySelectorAll(".fragment.visible").length - 1;
                }
            }
            return {
                h: s,
                v: a,
                f: i
            };
        }
        function at() {
            return t(X.wrapper, b + ':not(.stack):not([data-visibility="uncounted"])');
        }
        function nt() {
            return t(X.wrapper, w);
        }
        function rt() {
            return t(X.wrapper, ".slides>section>section");
        }
        function ot() {
            return nt().length > 1;
        }
        function lt() {
            return rt().length > 1;
        }
        function dt() {
            return at().length;
        }
        function ct(e, t) {
            let i = nt()[e], s = i && i.querySelectorAll("section");
            return s && s.length && "number" == typeof t ? s ? s[t] : void 0 : i;
        }
        function ht() {
            let e = st();
            return {
                indexh: e.h,
                indexv: e.v,
                indexf: e.f,
                paused: $e(),
                overview: oe.isActive()
            };
        }
        function ut() {
            if (gt(), f && !1 !== R.autoSlide) {
                let e = f.querySelector(".current-fragment[data-autoslide]"), i = e ? e.getAttribute("data-autoslide") : null, s = f.parentNode ? f.parentNode.getAttribute("data-autoslide") : null, a = f.getAttribute("data-autoslide");
                i ? _ = parseInt(i, 10) : a ? _ = parseInt(a, 10) : s ? _ = parseInt(s, 10) : (_ = R.autoSlide, 0 === f.querySelectorAll(".fragment").length && t(f, "video, audio").forEach((e)=>{
                    e.hasAttribute("data-autoplay") && _ && 1e3 * e.duration / e.playbackRate > _ && (_ = 1e3 * e.duration / e.playbackRate + 1e3);
                })), !_ || Q || $e() || oe.isActive() || Ue() && !re.availableRoutes().next && !0 !== R.loop || (J = setTimeout(()=>{
                    "function" == typeof R.autoSlideMethod ? R.autoSlideMethod() : Et(), ut();
                }, _), G = Date.now()), A && A.setPlaying(-1 !== J);
            }
        }
        function gt() {
            clearTimeout(J), J = -1;
        }
        function pt() {
            _ && !Q && (Q = !0, Le({
                type: "autoslidepaused"
            }), clearTimeout(J), A && A.setPlaying(!1));
        }
        function vt() {
            _ && Q && (Q = !1, Le({
                type: "autoslideresumed"
            }), ut());
        }
        function mt({ skipFragments: e = !1 } = {}) {
            z.hasNavigatedHorizontally = !0, R.rtl ? (oe.isActive() || e || !1 === re.next()) && tt().left && Xe(c + 1, "grid" === R.navigationMode ? u : void 0) : (oe.isActive() || e || !1 === re.prev()) && tt().left && Xe(c - 1, "grid" === R.navigationMode ? u : void 0);
        }
        function ft({ skipFragments: e = !1 } = {}) {
            z.hasNavigatedHorizontally = !0, R.rtl ? (oe.isActive() || e || !1 === re.prev()) && tt().right && Xe(c - 1, "grid" === R.navigationMode ? u : void 0) : (oe.isActive() || e || !1 === re.next()) && tt().right && Xe(c + 1, "grid" === R.navigationMode ? u : void 0);
        }
        function yt({ skipFragments: e = !1 } = {}) {
            (oe.isActive() || e || !1 === re.prev()) && tt().up && Xe(c, u - 1);
        }
        function bt({ skipFragments: e = !1 } = {}) {
            z.hasNavigatedVertically = !0, (oe.isActive() || e || !1 === re.next()) && tt().down && Xe(c, u + 1);
        }
        function wt({ skipFragments: e = !1 } = {}) {
            if (e || !1 === re.prev()) {
                if (tt().up) yt({
                    skipFragments: e
                });
                else {
                    let i;
                    if (i = R.rtl ? t(X.wrapper, w + ".future").pop() : t(X.wrapper, w + ".past").pop(), i && i.classList.contains("stack")) {
                        let e = i.querySelectorAll("section").length - 1 || void 0;
                        Xe(c - 1, e);
                    } else mt({
                        skipFragments: e
                    });
                }
            }
        }
        function Et({ skipFragments: e = !1 } = {}) {
            if (z.hasNavigatedHorizontally = !0, z.hasNavigatedVertically = !0, e || !1 === re.next()) {
                let t = tt();
                t.down && t.right && R.loop && Oe() && (t.down = !1), t.down ? bt({
                    skipFragments: e
                }) : R.rtl ? mt({
                    skipFragments: e
                }) : ft({
                    skipFragments: e
                });
            }
        }
        function St(e) {
            let t = e.data;
            if ("string" == typeof t && "{" === t.charAt(0) && "}" === t.charAt(t.length - 1) && (t = JSON.parse(t), t.method && "function" == typeof d[t.method])) {
                if (!1 === S.test(t.method)) {
                    const e = d[t.method].apply(d, t.args);
                    xe("callback", {
                        method: t.method,
                        result: e
                    });
                } else console.warn('reveal.js: "' + t.method + '" is is blacklisted from the postMessage API');
            }
        }
        function At(e) {
            "running" === Y && /section/gi.test(e.target.nodeName) && (Y = "idle", Le({
                type: "slidetransitionend",
                data: {
                    indexh: c,
                    indexv: u,
                    previousSlide: g,
                    currentSlide: f
                }
            }));
        }
        function Rt(e) {
            const t = r(e.target, 'a[href^="#"]');
            if (t) {
                const i = t.getAttribute("href"), s = de.getIndicesFromHash(i);
                s && (d.slide(s.h, s.v, s.f), e.preventDefault());
            }
        }
        function kt(e) {
            Be();
        }
        function Lt(e) {
            !1 === document.hidden && document.activeElement !== document.body && ("function" == typeof document.activeElement.blur && document.activeElement.blur(), document.body.focus());
        }
        function Ct(e) {
            (document.fullscreenElement || document.webkitFullscreenElement) === X.wrapper && (e.stopImmediatePropagation(), setTimeout(()=>{
                d.layout(), d.focus.focus();
            }, 1));
        }
        function xt(e) {
            if (e.currentTarget && e.currentTarget.hasAttribute("href")) {
                let t = e.currentTarget.getAttribute("href");
                t && (Ne(t), e.preventDefault());
            }
        }
        function Pt(e) {
            Ue() && !1 === R.loop ? (Xe(0, 0), vt()) : Q ? vt() : pt();
        }
        const Tt = {
            VERSION: j,
            initialize: function(e) {
                if (!n) throw 'Unable to find presentation root (<div class="reveal">).';
                if (X.wrapper = n, X.slides = n.querySelector(".slides"), !X.slides) throw 'Unable to find slides container (<div class="slides">).';
                return R = {
                    ...V,
                    ...R,
                    ...o,
                    ...e,
                    ...l()
                }, /print-pdf/gi.test(window.location.search) && (R.view = "print"), function() {
                    !0 === R.embedded ? X.viewport = r(n, ".reveal-viewport") || n : (X.viewport = document.body, document.documentElement.classList.add("reveal-full-page"));
                    X.viewport.classList.add("reveal-viewport");
                }(), window.addEventListener("load", Be, !1), ge.load(R.plugins, R.dependencies).then(fe), new Promise((e)=>d.on("ready", e));
            },
            configure: we,
            destroy: function() {
                Se(), gt(), Te(), me.destroy(), pe.destroy(), ge.destroy(), ue.destroy(), ce.destroy(), he.destroy(), se.destroy(), ee.destroy(), te.destroy(), document.removeEventListener("fullscreenchange", Ct), document.removeEventListener("webkitfullscreenchange", Ct), document.removeEventListener("visibilitychange", Lt, !1), window.removeEventListener("message", St, !1), window.removeEventListener("load", Be, !1), X.pauseOverlay && X.pauseOverlay.remove(), X.statusElement && X.statusElement.remove(), document.documentElement.classList.remove("reveal-full-page"), X.wrapper.classList.remove("ready", "center", "has-horizontal-slides", "has-vertical-slides"), X.wrapper.removeAttribute("data-transition-speed"), X.wrapper.removeAttribute("data-background-transition"), X.viewport.classList.remove("reveal-viewport"), X.viewport.style.removeProperty("--slide-width"), X.viewport.style.removeProperty("--slide-height"), X.slides.style.removeProperty("width"), X.slides.style.removeProperty("height"), X.slides.style.removeProperty("zoom"), X.slides.style.removeProperty("left"), X.slides.style.removeProperty("top"), X.slides.style.removeProperty("bottom"), X.slides.style.removeProperty("right"), X.slides.style.removeProperty("transform"), Array.from(X.wrapper.querySelectorAll(b)).forEach((e)=>{
                    e.style.removeProperty("display"), e.style.removeProperty("top"), e.removeAttribute("hidden"), e.removeAttribute("aria-hidden");
                });
            },
            sync: _e,
            syncSlide: function(e = f) {
                se.sync(e), re.sync(e), Z.load(e), se.update(), me.update();
            },
            syncFragments: re.sync.bind(re),
            slide: Xe,
            left: mt,
            right: ft,
            up: yt,
            down: bt,
            prev: wt,
            next: Et,
            navigateLeft: mt,
            navigateRight: ft,
            navigateUp: yt,
            navigateDown: bt,
            navigatePrev: wt,
            navigateNext: Et,
            navigateFragment: re.goto.bind(re),
            prevFragment: re.prev.bind(re),
            nextFragment: re.next.bind(re),
            on: Ae,
            off: Re,
            addEventListener: Ae,
            removeEventListener: Re,
            layout: Be,
            shuffle: Je,
            availableRoutes: tt,
            availableFragments: re.availableRoutes.bind(re),
            toggleHelp: function(e) {
                "boolean" == typeof e ? e ? Me() : Ie() : X.overlay ? Ie() : Me();
            },
            toggleOverview: oe.toggle.bind(oe),
            toggleScrollView: ae.toggle.bind(ae),
            togglePause: Ke,
            toggleAutoSlide: function(e) {
                "boolean" == typeof e ? e ? vt() : pt() : Q ? vt() : pt();
            },
            toggleJumpToSlide: function(e) {
                "boolean" == typeof e ? e ? te.show() : te.hide() : te.isVisible() ? te.hide() : te.show();
            },
            isFirstSlide: We,
            isLastSlide: Ue,
            isLastVerticalSlide: Oe,
            isVerticalSlide: qe,
            isVerticalStack: function(e = f) {
                return e.classList.contains(".stack") || null !== e.querySelector("section");
            },
            isPaused: $e,
            isAutoSliding: function() {
                return !(!_ || Q);
            },
            isSpeakerNotes: me.isSpeakerNotesWindow.bind(me),
            isOverview: oe.isActive.bind(oe),
            isFocused: pe.isFocused.bind(pe),
            isScrollView: ae.isActive.bind(ae),
            isPrintView: ne.isActive.bind(ne),
            isReady: ()=>H,
            loadSlide: Z.load.bind(Z),
            unloadSlide: Z.unload.bind(Z),
            startEmbeddedContent: ()=>Z.startEmbeddedContent(f),
            stopEmbeddedContent: ()=>Z.stopEmbeddedContent(f, {
                    unloadIframes: !1
                }),
            showPreview: Ne,
            hidePreview: Ie,
            addEventListeners: Ee,
            removeEventListeners: Se,
            dispatchEvent: Le,
            getState: ht,
            setState: function(e) {
                if ("object" == typeof e) {
                    Xe(s(e.indexh), s(e.indexv), s(e.indexf));
                    let t = s(e.paused), i = s(e.overview);
                    "boolean" == typeof t && t !== $e() && Ke(t), "boolean" == typeof i && i !== oe.isActive() && oe.toggle(i);
                }
            },
            getProgress: function() {
                let e = dt(), t = it();
                if (f) {
                    let e = f.querySelectorAll(".fragment");
                    if (e.length > 0) {
                        let i = .9;
                        t += f.querySelectorAll(".fragment.visible").length / e.length * i;
                    }
                }
                return Math.min(t / (e - 1), 1);
            },
            getIndices: st,
            getSlidesAttributes: function() {
                return at().map((e)=>{
                    let t = {};
                    for(let i = 0; i < e.attributes.length; i++){
                        let s = e.attributes[i];
                        t[s.name] = s.value;
                    }
                    return t;
                });
            },
            getSlidePastCount: it,
            getTotalSlides: dt,
            getSlide: ct,
            getPreviousSlide: ()=>g,
            getCurrentSlide: ()=>f,
            getSlideBackground: function(e, t) {
                let i = "number" == typeof e ? ct(e, t) : e;
                if (i) return i.slideBackgroundElement;
            },
            getSlideNotes: me.getSlideNotes.bind(me),
            getSlides: at,
            getHorizontalSlides: nt,
            getVerticalSlides: rt,
            hasHorizontalSlides: ot,
            hasVerticalSlides: lt,
            hasNavigatedHorizontally: ()=>z.hasNavigatedHorizontally,
            hasNavigatedVertically: ()=>z.hasNavigatedVertically,
            shouldAutoAnimateBetween: Ye,
            addKeyBinding: le.addKeyBinding.bind(le),
            removeKeyBinding: le.removeKeyBinding.bind(le),
            triggerKey: le.triggerKey.bind(le),
            registerKeyboardShortcut: le.registerKeyboardShortcut.bind(le),
            getComputedSlideSize: De,
            setCurrentScrollPage: function(e, t, i) {
                let s = c || 0;
                c = t, u = i;
                const a = f !== e;
                g = f, f = e, f && g && R.autoAnimate && Ye(g, f, s, u) && ie.run(g, f), a && (g && (Z.stopEmbeddedContent(g), Z.stopEmbeddedContent(g.slideBackgroundElement)), Z.startEmbeddedContent(f), Z.startEmbeddedContent(f.slideBackgroundElement)), requestAnimationFrame(()=>{
                    ye(be(f));
                }), Ce();
            },
            getScale: ()=>K,
            getConfig: ()=>R,
            getQueryHash: l,
            getSlidePath: de.getHash.bind(de),
            getRevealElement: ()=>n,
            getSlidesElement: ()=>X.slides,
            getViewportElement: ()=>X.viewport,
            getBackgroundsElement: ()=>se.element,
            registerPlugin: ge.registerPlugin.bind(ge),
            hasPlugin: ge.hasPlugin.bind(ge),
            getPlugin: ge.getPlugin.bind(ge),
            getPlugins: ge.getRegisteredPlugins.bind(ge)
        };
        return e(d, {
            ...Tt,
            announceStatus: ye,
            getStatusText: be,
            focus: pe,
            scroll: ae,
            progress: he,
            controls: ce,
            location: de,
            overview: oe,
            fragments: re,
            backgrounds: se,
            slideContent: Z,
            slideNumber: ee,
            onUserInput: function(e) {
                R.autoSlideStoppable && pt();
            },
            closeOverlay: Ie,
            updateSlidesVisibility: et,
            layoutSlideContents: He,
            transformSlides: ke,
            cueAutoSlide: ut,
            cancelAutoSlide: gt
        }), Tt;
    }
    let $ = K, X = [];
    return $.initialize = (e)=>(Object.assign($, new K(document.querySelector(".reveal"), e)), X.map((e)=>e($)), $.initialize()), [
        "configure",
        "on",
        "off",
        "addEventListener",
        "removeEventListener",
        "registerPlugin"
    ].forEach((e)=>{
        $[e] = (...t)=>{
            X.push((i)=>i[e].call(null, ...t));
        };
    }), $.isReady = ()=>!1, $.VERSION = j, $;
});

//# sourceMappingURL=tooling.reveal.62c78f3a.js.map
